{
  "action": {
    "accept": "Accetto",
    "acceptRedundancy": "Conferma ridondante",
    "activate": "Attiva",
    "add": "Aggiungi",
    "addExistingDocument": "Aggiungi documento esistente",
    "addField": "Aggiungi campo",
    "addFieldMapping": "Aggiungi mappatura",
    "addHint": "Premi invio per aggiungere",
    "addIntegration": "Aggiungi integrazione",
    "addMember": "Aggiungi membro",
    "addNestedField": "Campo annidato",
    "addToCalendar": "Aggiungi al calendario",
    "allDocuments": "Tutti i documenti",
    "analyzeChat": "Analizza conversazione",
    "apply": "Applica",
    "ask": "Chiedi",
    "attachFile": "Allega un file",
    "back": "Indietro",
    "backToAgent": "Torna all'agente",
    "backToDocuments": "Torna ai documenti",
    "backToHome": "Torna alla Home",
    "backToSignIn": "Torna al login",
    "ban": "Banna utente",
    "blockChat": "Blocca conversazione",
    "cancel": "Annulla",
    "cancelInvitation": "Annulla invito",
    "change": "Modifica",
    "changeAgent": "Cambia agente",
    "changeRole": "Cambia ruolo",
    "check": "Verifica",
    "clear": "Pulisci",
    "clearSearch": "Cancella ricerca",
    "close": "Chiudi",
    "closeSidebar": "Chiudi la sidebar",
    "collapse": "Collassa",
    "compare": "Confronta",
    "connect": "Collega",
    "continue": "Continua",
    "copied": "Copiato",
    "copy": "Copia",
    "crawl": "Esegui Crawling",
    "create": "Crea",
    "createAgent": "Crea agente",
    "createApiKey": "Crea API Key",
    "createDocument": "Crea documento",
    "createFolder": "Crea cartella",
    "createNew": "Crea nuovo",
    "createNewChat": "Inizia una nuova chat",
    "createNotification": "Crea notifica",
    "createRevise": "Correggi la risposta",
    "createSubfolder": "Crea sottocartella",
    "deactivate": "Disattiva",
    "decline": "Rifiuto",
    "delete": "Elimina",
    "deleteAllMemories": "Elimina tutte le memorie",
    "deleteAllNotifications": "Elimina tutte le notifiche",
    "deleteFolder": "Elimina cartella",
    "deleteMyConversations": "Cancella le mie conversazioni",
    "deleteProfile": "Elimina profilo",
    "deleteRow": "Elimina riga",
    "deselectHint": "Premi invio per rimuovere",
    "disableAutoRefresh": "Disabilita aggiornamento automatico",
    "disconnect": "Disconnetti",
    "embeddingBackToPlatform": "Torna alla piattaforma",
    "embeddingRemove": "Rimuovi",
    "embeddingUseEndpoint": "Usa l’endpoint",
    "modelEndpointConnect": "Collega il tuo endpoint",
    "dismissRedundancy": "Ripristina nella ricerca",
    "documentRefreshNow": "Aggiorna ora",
    "documentSetRefresh": "Imposta aggiornamento",
    "documentSourceSettings": "Impostazioni di sincronizzazione",
    "documentSourceSyncNow": "Sincronizza ora",
    "documentSourceUnlink": "Scollega",
    "download": "Scarica",
    "downloadIcs": "Scarica .ics",
    "downloadTeamsApp": "Scarica app Teams (.zip)",
    "downvote": "Non mi piace",
    "dropFile": "Trascina il file qui",
    "dropFilesToImport": "Rilascia i file per importare i documenti",
    "duplicate": "Duplica",
    "edit": "Modifica",
    "editAgent": "Modifica agente",
    "editDocument": "Modifica documento",
    "editRevise": "Modifica la risposta",
    "editSchema": "Modifica schema",
    "enableAutoRefresh": "Abilita aggiornamento automatico",
    "expand": "Espandi",
    "export": "Esporta",
    "exportMyData": "Esporta i miei dati",
    "feedback": "Voglio fare una segnalazione",
    "foldSidebar": "Chiudi barra laterale",
    "forgetPassword": "Hai dimenticato la password?",
    "generate": "Genera",
    "generateFromJson": "Genera da JSON",
    "getDirections": "Indicazioni",
    "getMoreInfo": "Maggiori informazioni",
    "goBack": "Indietro",
    "hangUp": "Chiudi la chiamata",
    "impersonate": "Impersonifica",
    "import": "Importa ({count})",
    "importFromCrawler": "Importa da Crawler",
    "integrationCheck": "Verifica connessione",
    "integrationConnectMicrosoft": "Connetti con Microsoft",
    "integrationConnectApp": "Collega l'app",
    "integrationUseOwnApp": "Usa un'app del vostro tenant",
    "integrationAdvancedSetup": "Configurazione avanzata",
    "integrationDisconnect": "Disconnetti",
    "integrationReconnect": "Riconnetti",
    "integrationRotateSecret": "Sostituisci il client secret",
    "invite": "Invita",
    "inviteMember": "Invita membro",
    "leave": "Abbandona",
    "link": "Collega",
    "linkExisting": "Collega esistente",
    "linkFromProvider": "Collega da {provider}",
    "loadDefaults": "Carica default",
    "manageAgentAccess": "Gestisci accesso agenti",
    "manageProfile": "Gestisci il tuo profilo",
    "markAllAsRead": "Segna tutto come letto",
    "markAsRead": "Segna come letto",
    "moreActions": "Azioni",
    "moveDown": "Sposta giù",
    "moveHere": "Sposta qui",
    "moveToFolder": "Sposta nella cartella",
    "moveUp": "Sposta su",
    "mute": "Disattiva il microfono",
    "next": "Avanti",
    "open": "Apri",
    "openFilters": "Apri i filtri",
    "openInGmail": "Apri in Gmail",
    "openInMailApp": "Apri con l'app di posta",
    "openInOutlook": "Apri in Outlook",
    "openInSms": "Apri in SMS",
    "openInTelegram": "Apri in Telegram",
    "openInWhatsApp": "Apri in WhatsApp",
    "openInYahooMail": "Apri in Yahoo Mail",
    "openSettings": "Apri le impostazioni",
    "openSidebar": "Apri la sidebar",
    "pan": "Sposta",
    "pause": "Metti in pausa",
    "pin": "Blocca",
    "playVoicePreview": "Ascolta un esempio di questa voce",
    "prev": "Indietro",
    "previewAsPage": "Anteprima come pagina chat",
    "previewAsWidget": "Anteprima come widget",
    "previous": "Indietro",
    "proceed": "Procedi",
    "profileMenu": "Profilo, tema e lingua",
    "recoverPassword": "Recupera password",
    "refill": "Ricarica",
    "refillHistory": "Storico ricariche",
    "refresh": "Aggiorna",
    "refreshPrices": "Aggiorna i prezzi",
    "setPrice": "Imposta il prezzo",
    "regenerate": "Rigenera",
    "remove": "Rimuovi",
    "removeField": "Rimuovi campo",
    "renameChat": "Rinomina",
    "renameFolder": "Rinomina cartella",
    "reorder": "Riordina",
    "reprocess": "Riprocessa",
    "resendInvitation": "Invia nuovamente l'invito",
    "reset": "Reset",
    "resetPassword": "Reimposta password",
    "resize": "Ridimensiona",
    "resume": "Riprendi",
    "resumeInPlayground": "Riprendi nel playground",
    "retry": "Riprova",
    "retryNow": "Riprova ora",
    "revoke": "Revoca",
    "revokeAllOtherSessions": "Disconnetti tutte",
    "revokeAllSessions": "Revoca tutte le sessioni",
    "run": "Esegui",
    "save": "Salva",
    "scrollToBottom": "Torna in fondo",
    "searchAllFolders": "Cerca in tutte le cartelle",
    "select": "Seleziona",
    "selectHint": "Premi invio per selezionare",
    "selected": "Selezionati",
    "send": "Invia",
    "sendLink": "Invia il link",
    "share": "Condividi",
    "shareDocumentWithAgents": "Condividi con altri agenti",
    "showLess": "Mostra di meno",
    "showMore": "Visualizza altre {count}",
    "signIn": "Accedi",
    "signInWithSocialProvider": "Accedi con {provider}",
    "signOut": "Esci",
    "signUp": "Registrati",
    "signUpWithSocialProvider": "Registrati con {provider}",
    "startNewChat": "Inizia una nuova chat",
    "stop": "Ferma",
    "stopImpersonation": "Torna al tuo profilo",
    "stopVoicePreview": "Ferma l'esempio",
    "submit": "Invia",
    "switch": "Cambia",
    "takePhoto": "Scatta una foto",
    "talk": "Parla",
    "testIntegration": "Verifica connessione",
    "toggleIntegration": "Abilita/Disabilita",
    "toggleTheme": "Cambia tema",
    "unban": "Sblocca utente",
    "unblockChat": "Sblocca conversazione",
    "unfoldSidebar": "Apri barra laterale",
    "unlinkDocument": "Rimuovi dall'agente",
    "unmute": "Riattiva il microfono",
    "unpin": "Sblocca",
    "update": "Aggiorna",
    "upvote": "Mi piace!",
    "useColorsForAgentHeader": "Colora l'intestazione",
    "view": "Visualizza",
    "viewAgentTree": "Dipendenze",
    "viewAll": "Vedi tutte",
    "viewChat": "Visualizza la chat",
    "viewDetails": "Visualizza dettagli",
    "viewDocument": "Visualizza il documento",
    "viewDocuments": "Visualizza i documenti",
    "viewProfile": "Visualizza profilo",
    "viewRecentChats": "Visualizza chat recenti",
    "welcomePopup": "Mostra popup di benvenuto",
    "writeMessage": "Scrivi un messaggio",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci",
    "createWebSource": "Crea sorgente",
    "webSourceConfirmRemoval": "Rimuovi le {count} pagine"
  },
  "agent": {
    "channel": {
      "app": "App",
      "frontoffice": "Frontoffice",
      "widget": "Widget"
    },
    "reasoning": {
      "high": "Alto",
      "low": "Basso",
      "medium": "Medio",
      "off": "Disattivo"
    },
    "reasoningSummary": {
      "auto": "Auto",
      "concise": "Conciso",
      "detailed": "Dettagliato"
    },
    "searchMode": {
      "balanced": "Bilanciato (vettoriale + parole chiave)",
      "keyword": "Parole chiave (solo full-text)",
      "semantic": "Semantico (solo vettoriale)"
    },
    "status": {
      "active": "Attivo",
      "draft": "Bozza",
      "inactive": "Inattivo"
    },
    "tool": {
      "fetchTeamsChannelHistory": "Cronologia canale Teams",
      "geocode": "Geocodifica",
      "getWeather": "Dati meteo",
      "readDocumentFile": "Lettura file documenti",
      "requestGeolocation": "Geolocalizzazione",
      "retrieveRevisedAnswers": "Risposte verificate",
      "runWorker": "Worker parallelo",
      "searchInKnowledgeBase": "Knowledge base",
      "searchInUserFiles": "File dell'utente",
      "showArtifact": "Artefatti",
      "showCalendarEvent": "Evento calendario",
      "showComparison": "Confronto",
      "showContactForm": "Modulo di contatto",
      "showDiagram": "Diagramma o grafico",
      "showEmail": "Email",
      "showForm": "Modulo multi-step",
      "showImageGallery": "Galleria immagini",
      "showLocation": "Mappa interattiva",
      "showMessage": "Messaggistica",
      "showMultipleChoice": "Scelta multipla",
      "showProductList": "Catalogo prodotti",
      "showQrCode": "Codice QR",
      "showSources": "Fonti e riferimenti",
      "showSuggestedReply": "Risposte suggerite",
      "showVideo": "Video",
      "showWeather": "Widget meteo",
      "showWebPages": "Link a pagine web",
      "useAllUserFiles": "Utilizza tutti i file utente",
      "useAllUserKb": "Utilizza tutta la KB utente",
      "userMemory": "Memoria utente"
    },
    "toolWorkingSetMode": {
      "active": "Attiva",
      "off": "Disattivata",
      "shadow": "Ombra (solo registrazione)"
    },
    "visibility": {
      "organization": "Organizzazione",
      "private": "Privato",
      "public": "Pubblico"
    }
  },
  "agentApiToolStatus": {
    "active": "Attivo",
    "inactive": "Inattivo"
  },
  "agentType": {
    "chat": "Chat",
    "reasoning": "Ragionamento"
  },
  "auth": {
    "genericError": "Si è verificato un errore. Riprova.",
    "haveAccount": "Hai già un account?",
    "noAccount": "Non hai un account?",
    "popupBlocked": "Finestra popup bloccata. Consenti i popup per questo sito e riprova.",
    "resetSent": "Se esiste un account con questa email, riceverai un link per reimpostare la password.",
    "resetSentTitle": "Controlla la tua email",
    "resetTitle": "Reimposta la tua password",
    "signInTitle": "Accedi al tuo account",
    "signUpSuccessTitle": "Account creato!",
    "signUpTitle": "Crea il tuo account",
    "verifyEmail": "Abbiamo inviato un'email di verifica al tuo indirizzo. Controlla la tua casella di posta."
  },
  "browserEngine": {
    "fetch": "Fetch · HTML statico",
    "puppeteer": "Puppeteer · browser locale",
    "remote": "Remote · browser remoto"
  },
  "channelDescription": {
    "teams": "Pubblica questo agente come bot all'interno di Microsoft Teams.",
    "whatsapp": "Permetti agli utenti di scrivere a questo agente su WhatsApp tramite le API Meta Cloud."
  },
  "channelGuide": {
    "docs": "Apri la documentazione ufficiale",
    "intro": "Segui i passaggi nell'ordine. Apri ogni servizio collegato in una nuova scheda del browser e copia i valori nel form a sinistra. Non chiudere questa finestra finché non hai finito.",
    "teams": {
      "step1": "Accedi al portale Microsoft Azure con il tuo account aziendale o scolastico.",
      "step2": "Crea una nuova risorsa «Azure Bot» e dalle un nome. Quando richiesto, scegli se è Single o Multi-tenant — ricorda la scelta per il passaggio 5.",
      "step3": "Apri il bot appena creato → «Configuration», copia il «Microsoft App ID» e incollalo nel campo App ID.",
      "step4": "Accanto al Microsoft App ID clicca «Manage password»: si apre la registrazione dell'app in Microsoft Entra ID (una pagina diversa dal bot). Lì, sotto «Certificates & secrets», crea un nuovo client secret e copia il suo «Value» (non il Secret ID) nel campo App password. Copialo subito — viene mostrato una sola volta.",
      "step5": "Imposta l'App type uguale a quanto scelto al passaggio 2. Per Single tenant, copia il «Directory (tenant) ID» dalla pagina «Overview» della registrazione dell'app nel campo Tenant ID.",
      "step6": "Torna nel bot → «Configuration», imposta il «Messaging endpoint» sul Webhook URL mostrato sopra e salva.",
      "step7": "Apri il bot → «Channels» e aggiungi il canale «Microsoft Teams».",
      "step8": "Salva il form a sinistra, poi usa il menu della card (⋯ → Scarica app Teams) per ottenere il pacchetto e caricalo in Teams da «App → Gestisci le tue app → Carica un'app»."
    },
    "title": "Guida alla configurazione",
    "whatsapp": {
      "step1": "Apri il portale Meta for Developers e accedi con il tuo account Facebook (creane uno se non ce l'hai).",
      "step2": "Crea una nuova app: scegli il tipo «Business», dai un nome, poi aggiungi il prodotto «WhatsApp».",
      "step3": "Apri WhatsApp → «API Setup». Copia il «Phone number ID» (un numero lungo, non il numero di telefono) e incollalo nel campo Phone number ID.",
      "step4": "Sempre in «API Setup», genera un access token. Per una connessione che non scade, crea un token «System User» con il permesso whatsapp_business_messaging e incollalo nel campo Access token.",
      "step5": "Apri Impostazioni app → «Base», clicca «Mostra» accanto a «Chiave segreta dell'app», copiala e incollala nel campo App secret. Serve a verificare che i messaggi in arrivo provengano davvero da Meta.",
      "step6": "Abbiamo già compilato il campo «Verify token» con un valore pronto all'uso (usa «Rigenera» per crearne uno nuovo). Incollerai esattamente questo valore in Meta al passaggio successivo.",
      "step7": "Torna su WhatsApp → «Configuration» e modifica il webhook: incolla il Webhook URL mostrato sopra e lo stesso Verify token, salva, poi iscriviti all'evento «messages».",
      "step8": "Salva il form a sinistra. Invia un messaggio al tuo numero WhatsApp per verificare che l'agente risponda."
    }
  },
  "chartLabel": {
    "2g": "2G",
    "3g": "3G",
    "4g": "4G",
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Australia": "Australia",
    "Europe": "Europa",
    "Pacific": "Pacifico",
    "abusive": "Offensivo",
    "aggressive": "Aggressivo",
    "api": "API",
    "critical": "Critico",
    "dark": "Scuro",
    "data_leak": "Fuga di dati",
    "degrading": "In peggioramento",
    "desktop": "Desktop",
    "direct": "Diretto",
    "disengaged": "Disinteressato",
    "endpoint": "Endpoint",
    "excited": "Entusiasta",
    "false_success": "Falso successo",
    "frustrated": "Frustrato",
    "goal_met": "Obiettivo raggiunto",
    "goal_not_met": "Obiettivo non raggiunto",
    "group": "Gruppo",
    "hallucination": "Allucinazione",
    "high": "Alto",
    "impatient": "Impaziente",
    "improving": "In miglioramento",
    "inappropriate_tone": "Tono inappropriato",
    "light": "Chiaro",
    "low": "Basso",
    "medium": "Medio",
    "mobile": "Mobile",
    "negative": "Negativo",
    "neutral": "Neutro",
    "off_brand": "Fuori tono",
    "other": "Altro",
    "polite": "Cortese",
    "positive": "Positivo",
    "reasoning": "Reasoning",
    "refusal_loop": "Loop di rifiuto",
    "repetition": "Ripetizione",
    "slow-2g": "2G lento",
    "stable": "Stabile",
    "tablet": "Tablet",
    "teams": "Teams",
    "unanalyzed": "Non analizzato",
    "unclear": "Non chiaro",
    "unknown": "Sconosciuto",
    "voice": "Voce",
    "web": "Web",
    "whatsapp": "WhatsApp"
  },
  "confirmDescription": {
    "documentRefreshTriggerOff": "Altrimenti la lettura successiva sovrascriverebbe quello che avete scritto. Potete riaccenderlo dalla card dell'aggiornamento.",
    "embeddingBackToPlatform": "La base di conoscenza e le memorie vengono ricalcolate con il modello della piattaforma, dal testo già salvato: niente viene riconvertito. Finché non ha finito, le ricerche trovano solo ciò che è già tornato.",
    "embeddingBackToPlatformSameFamily": "Il tuo endpoint calcola lo stesso modello della piattaforma, quindi i vettori restano quelli che ci sono e non si ricalcola niente: da adesso li calcola il gateway AI della piattaforma.",
    "embeddingRemove": "Senza il gateway AI della piattaforma nessun altro calcola i vettori: la base di conoscenza, le risposte corrette, le memorie e l’elaborazione dei documenti si fermano finché non attivi di nuovo un modello di embedding sul tuo endpoint. Se la piattaforma riaccende il gateway, ripartono da sole sui suoi vettori.",
    "endpointOffWithEmbedding": "Oltre ai suoi modelli si fermano la base di conoscenza, le risposte corrette, le memorie e l’elaborazione dei documenti di tutti gli agenti, finché non lo riaccendi.",
    "integrationDisconnect": "Restano dove sono con i loro documenti, modificabili come gli altri, e smettono di aggiornarsi. Per sincronizzarle di nuovo dovrete ricollegare il provider e collegarle un'altra volta.",
    "integrationRemove": "Le credenziali salvate vengono cancellate e le sincronizzazioni verso questo provider si fermano. Per riprenderle dovrete configurarlo di nuovo.",
    "lastModelOff": "Nessun altro modello di questa organizzazione è acceso: non se ne potrà più scegliere uno per un agente nuovo o come predefinito, e gli agenti che li usano risponderanno con il modello predefinito.",
    "modelProviderDelete": "I modelli salvati e i loro prezzi andranno persi. L'eliminazione non è possibile finché un agente usa uno dei suoi modelli, né finché l’endpoint calcola l’embedding: sposta prima quegli agenti su un altro modello, e rimuovi l’embedding nella sezione Embedding.",
    "modelRemove": "Gli agenti che usano questo modello smetteranno di rispondere finché non li sposti su un altro modello.",
    "revokeVoiceApiKey": "Questa chiave serve il canale voce di un agente: la voce smette di funzionare finché non viene spenta e riaccesa nelle impostazioni dell'agente."
  },
  "confirmTitle": {
    "deleteAgent": "Eliminare questo agente?",
    "deleteAllMemories": "Eliminare tutte le memorie di questo utente?",
    "deleteBulkDocument": "Eliminare i documenti selezionati?",
    "deleteDocument": "Eliminare questo documento?",
    "deleteFolder": "Eliminare questa cartella?",
    "deleteMyConversations": "Eliminare tutte le vostre conversazioni?",
    "documentRefreshTriggerOff": "Spegnere l'aggiornamento automatico?",
    "embeddingBackToPlatform": "Calcolare di nuovo i vettori sulla piattaforma?",
    "embeddingBackToPlatformSameFamily": "Calcolare i vettori sulla piattaforma?",
    "embeddingRemove": "Rimuovere l’embedding dall’endpoint?",
    "endpointOffWithEmbedding": "Spegnere l’endpoint che calcola i vettori?",
    "excludeUserFile": "Rimuovere questo file dai vostri file?",
    "integrationDisconnect": "Rimuovere questa connessione?",
    "lastModelOff": "Spegnere l’ultimo modello?",
    "modelProviderDelete": "Eliminare l’endpoint?",
    "modelRemove": "Rimuovere {id}?",
    "unlinkAgent": "Rimuovere questo agente dal documento?",
    "unlinkDocument": "Disassociare questo documento dall'agente?",
    "unlinkLastAgentDelete": "Rimuovere l'ultimo agente da questo documento?",
    "unlinkSyncedFolder": "Scollegare questa cartella?",
    "webSourceConfirmRemoval": "Rimuovere {count} pagine?",
    "unlinkWebSource": "Scollegare la sorgente?"
  },
  "conversationAnalysis": {
    "abuseCategory": {
      "data_extraction": "Estrazione dati",
      "harassment": "Molestia",
      "hate_speech": "Incitamento all'odio",
      "impersonation": "Impersonificazione",
      "off_topic_persistent": "Fuori tema",
      "prompt_injection": "Prompt injection",
      "self_harm": "Autolesionismo",
      "sexual_content": "Contenuto sessuale",
      "spam": "Spam",
      "violence": "Violenza"
    },
    "confidence": {
      "high": "Alta",
      "low": "Bassa",
      "medium": "Media"
    },
    "engagement": {
      "disengaged": "Disimpegnato",
      "high": "Alto",
      "low": "Basso",
      "medium": "Medio"
    },
    "label": {
      "abuseDetected": "Abuso",
      "conversationSentiment": "Sentiment",
      "goalMet": "Obiettivo raggiunto",
      "goalNotMet": "Obiettivo non raggiunto",
      "llmIssueDetected": "Problema LLM",
      "riskScore": "Punteggio di rischio",
      "userEngagement": "Coinvolgimento",
      "userTone": "Tono"
    },
    "llmIssue": {
      "data_leak": "Fuga di dati",
      "false_success": "Falso successo",
      "hallucination": "Allucinazione",
      "inappropriate_tone": "Tono inappropriato",
      "off_brand": "Fuori brand",
      "refusal_loop": "Loop di rifiuto",
      "repetition": "Ripetizione"
    },
    "sentiment": {
      "excited": "Entusiasta",
      "frustrated": "Frustrato",
      "negative": "Negativo",
      "neutral": "Neutro",
      "positive": "Positivo"
    },
    "sentimentTrend": {
      "degrading": "In peggioramento",
      "improving": "In miglioramento",
      "stable": "Stabile"
    },
    "title": "Analisi conversazione",
    "tone": {
      "abusive": "Offensivo",
      "aggressive": "Aggressivo",
      "impatient": "Impaziente",
      "neutral": "Neutro",
      "polite": "Cortese"
    },
    "trigger": {
      "agent_request": "Su richiesta",
      "manual": "Manuale",
      "summary_cycle": "Automatico"
    }
  },
  "crawlMode": {
    "depth": "Pagina iniziale",
    "sitemap": "Sitemap XML"
  },
  "dataProtection": {
    "downloadPdf": "Scarica il PDF"
  },
  "diagram": {
    "classDiagram": "Diagramma di Classe",
    "erDiagram": "Diagramma ER",
    "flowchart": "Diagramma di Flusso",
    "graph": "Grafico",
    "sequenceDiagram": "Diagramma di Sequenza",
    "stateDiagram": "Diagramma di Stato",
    "xychart": "Grafico XY"
  },
  "documentMetadata": {
    "affectedDocumentsStat": "Documenti coinvolti",
    "analyzedPages": "analizzate {pages} su",
    "availableForSearch": "Disponibile per la ricerca dell'agente",
    "chunkSimilarTo": "Simile al {score}% a un contenuto in «{docName}»",
    "compare": "Confronta",
    "compareChunks": "Confronto Semantico Chunk",
    "filterOnlyRedundantLabel": "Mostra solo documenti con chunk ridondanti non gestiti",
    "filterRedundant": "Mostra ridondanti",
    "hasRedundant": "Questo documento contiene informazioni ridondanti con altri file",
    "isRedundant": "Ridondante",
    "notAvailableForSearch": "Non disponibile per la ricerca dell'agente",
    "openInProvider": "Apri in {provider}",
    "originalChunk": "Chunk Originale (Autorevole)",
    "pageCount": "nessuna pagina | {n} pagina | {n} pagine",
    "readingTime": "{minutes} min",
    "redundancyAccepted": "Confermato",
    "redundancyDismissed": "Ripristinato",
    "redundancyExplainer": "Questi blocchi ripetono un contenuto che l'agente trova già in un altro documento, o prima in questo, e la sua ricerca li salta. Conferma per lasciarli fuori, oppure ripristinali per rimetterli nella ricerca, in ogni agente.",
    "redundantChunk": "Chunk Ridondante (Duplicato)",
    "redundantChunks": "nessun chunk ridondante | {n} chunk ridondante ({percent}%) | {n} chunk ridondanti ({percent}%)",
    "redundantChunksStat": "Chunk ridondanti",
    "redundantWarningMessage": "Alcuni documenti contengono chunk ridondanti. Saranno esclusi automaticamente per ottimizzare il contesto del chatbot di recupero RAG.",
    "redundantWarningServerMessage": "Ci sono {chunks} chunk ridondanti non gestiti distribuiti in {docs} documenti di questo agente (su un totale di {totalChunks} chunk e {totalDocs} documenti).",
    "redundantWarningTitle": "Rilevati contenuti duplicati o ridondanti nella Knowledge Base",
    "redundantWith": "Ridondante con il chunk {chunkId} di {docName} ({score}% similarità semantica)",
    "searchNotSynced": "In preparazione",
    "searchSynced": "Disponibile",
    "showAll": "Mostra tutti",
    "thisDocument": "Questo documento",
    "viewByChunks": "Visualizza a chunk",
    "viewDocument": "Documento",
    "viewOriginal": "Vedi originale",
    "wordCount": "{count} parole"
  },
  "documentRefreshResult": {
    "failed": "Fallito",
    "gone": "Pagina sparita",
    "shrunk": "Rifiutato",
    "unchanged": "Invariato",
    "updated": "Aggiornato"
  },
  "documentStatus": {
    "failed": "Fallito",
    "pending": "In attesa",
    "processing": "In elaborazione",
    "success": "Completato"
  },
  "documentSyncCounter": {
    "scanned": "file esaminati",
    "added": "nuovi",
    "updated": "aggiornati",
    "renamedOrMoved": "rinominati o spostati",
    "removed": "rimossi",
    "unchanged": "invariati",
    "skippedUnsupported": "formati non supportati",
    "skippedTooLarge": "troppo grandi",
    "failed": "falliti",
    "scannedPages": "pagine esaminate",
    "capped": "rimandate al prossimo controllo"
  },
  "documentSyncInterval": {
    "daily": "Ogni giorno",
    "hourly": "Ogni ora",
    "monthly": "Ogni mese",
    "weekly": "Ogni settimana"
  },
  "documentSyncStatus": {
    "pending": "Primo import in corso",
    "syncing": "Sincronizzazione in corso",
    "idle": "Aggiornata",
    "error": "Errore"
  },
  "documentType": {
    "file": "File",
    "plain-text": "Testo",
    "revised-answer": "Risposta",
    "url": "Pagina web"
  },
  "errors": {
    "ACCOUNT_TEMPORARILY_LOCKED": "Troppi codici sbagliati: la verifica è bloccata per 15 minuti.",
    "BANNED_USER": "Questo account è stato bannato. Contatta l'assistenza se pensi che sia un errore.",
    "CREDENTIAL_ACCOUNT_NOT_FOUND": "Questo account accede con Google o Microsoft e non ha una password da cambiare",
    "EMAIL_CODE_NOT_AVAILABLE": "Questo account usa un'app di autenticazione: scrivi il suo codice o un codice di recupero.",
    "TWO_FACTOR_REQUIRED": "Un'organizzazione di questo account richiede la verifica in due passaggi: configurala per continuare",
    "PASSKEY_PASSWORD_REQUIRED": "Conferma la password per aggiungere una passkey",
    "PASSKEY_RECENT_SIGN_IN_REQUIRED": "Esci e accedi di nuovo per aggiungere una passkey",
    "PASSKEY_NOT_ALLOWED_FOR_SESSION": "Una passkey la aggiunge solo il titolare dell'account, dopo l'accesso",
    "PASSKEY_USER_VERIFICATION_REQUIRED": "Questa passkey non ha chiesto né PIN né impronta né volto: impostane uno sul dispositivo e riprova",
    "PASSKEY_NOT_FOUND": "Questa passkey non è collegata a nessun account: accedi con la password",
    "AUTHENTICATION_FAILED": "Non è stato possibile verificare la passkey: riprova",
    "FAILED_TO_VERIFY_REGISTRATION": "Non è stato possibile salvare la passkey: riprova",
    "CHALLENGE_NOT_FOUND": "La richiesta è scaduta: riprova",
    "EMAIL_NOT_VERIFIED": "Verifica il tuo indirizzo email",
    "EMAIL_VERIFICATION_REQUIRED_BEFORE_ACCEPTING_OR_REJECTING_INVITATION": "Verifica il tuo indirizzo email prima di rispondere all'invito",
    "FAILED_TO_UNLINK_LAST_ACCOUNT": "Non puoi scollegare l'unico metodo di accesso",
    "INVALID_BACKUP_CODE": "Il codice di recupero non è valido o è già stato usato.",
    "INVALID_CODE": "Il codice non è valido. Riprova.",
    "INVALID_EMAIL_OR_PASSWORD": "Email o password non validi",
    "INVALID_PASSWORD": "La password non è corretta",
    "INVALID_TOKEN": "Il link è scaduto o è già stato usato. Richiedine uno nuovo.",
    "INVALID_TWO_FACTOR_COOKIE": "La verifica è scaduta. Accedi di nuovo.",
    "INVITATION_LIMIT_REACHED": "Questa organizzazione ha raggiunto il limite di inviti",
    "INVITATION_NOT_FOUND": "L'invito non è più valido: potrebbe essere scaduto, annullato o avere già ricevuto una risposta",
    "INVITER_IS_NO_LONGER_A_MEMBER_OF_THE_ORGANIZATION": "Chi ti ha invitato non fa più parte dell'organizzazione, quindi l'invito non è più valido",
    "KEY_NOT_FOUND": "La chiave API non esiste più: potrebbe essere già stata eliminata",
    "MEMBER_NOT_FOUND": "Membro non trovato nell'organizzazione",
    "NOT_ALLOWED": "Non hai i permessi per questa operazione",
    "ORGANIZATION_ALREADY_EXISTS": "Esiste già un'organizzazione con questo slug",
    "ORGANIZATION_MEMBERSHIP_LIMIT_REACHED": "Questa organizzazione ha raggiunto il limite di membri",
    "ORGANIZATION_NOT_FOUND": "L'organizzazione non esiste più",
    "ORGANIZATION_SLUG_ALREADY_TAKEN": "Questo slug è già usato da un'altra organizzazione",
    "OTP_HAS_EXPIRED": "Il codice è scaduto. Chiedine uno nuovo.",
    "RATE_LIMIT_EXCEEDED": "Limite di richieste superato",
    "SESSION_NOT_FRESH": "Per sicurezza, accedi di nuovo e ripeti l'operazione",
    "SOCIAL_ACCOUNT_ALREADY_LINKED": "Questo account è già collegato a un altro utente",
    "TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE": "Troppi tentativi. Accedi di nuovo per ricevere un nuovo codice.",
    "TOO_MANY_REQUESTS": "Troppi tentativi. Attendi qualche minuto e riprova.",
    "TOTP_ALREADY_ENABLED": "La verifica in due passaggi con un'app è già attiva.",
    "TOTP_NOT_ENABLED": "Nessuna app di autenticazione è configurata per questo account.",
    "TWO_FACTOR_REQUIRED_TO_ENFORCE": "Attiva la verifica in due passaggi sul tuo account prima di renderla obbligatoria.",
    "UNAUTHORIZED_SESSION": "La sessione è scaduta. Accedi di nuovo.",
    "USER_ALREADY_EXISTS": "Esiste già un account con questa email",
    "USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL": "Esiste già un account con questa email",
    "USER_IS_ALREADY_A_MEMBER_OF_THIS_ORGANIZATION": "Questo utente fa già parte dell'organizzazione",
    "USER_IS_ALREADY_INVITED_TO_THIS_ORGANIZATION": "Questo utente è già stato invitato nell'organizzazione",
    "USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION": "Non fai parte di questa organizzazione",
    "USER_NOT_FOUND": "L'utente non esiste più",
    "YOU_ARE_NOT_A_MEMBER_OF_THIS_ORGANIZATION": "Non fai parte di questa organizzazione",
    "YOU_ARE_NOT_ALLOWED_TO_MANAGE_TWO_FACTOR": "Può farlo solo un amministratore di sistema, con il proprio account.",
    "YOU_ARE_NOT_THE_RECIPIENT_OF_THE_INVITATION": "Questo invito è stato inviato a un altro indirizzo email",
    "YOU_CANNOT_BAN_YOURSELF": "Non puoi bannare te stesso",
    "YOU_CANNOT_IMPERSONATE_ADMINS": "Non puoi impersonare un amministratore",
    "YOU_CANNOT_LEAVE_THE_ORGANIZATION_AS_THE_ONLY_OWNER": "Sei l'unico proprietario: nomina un altro proprietario prima di uscire",
    "YOU_CANNOT_LEAVE_THE_ORGANIZATION_WITHOUT_AN_OWNER": "L'organizzazione deve avere almeno un proprietario",
    "YOU_CANNOT_MANAGE_YOUR_OWN_TWO_FACTOR": "La tua verifica in due passaggi e le tue passkey si gestiscono dal profilo.",
    "YOU_CANNOT_REMOVE_YOURSELF": "Non puoi rimuovere te stesso",
    "YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS": "Hai raggiunto il numero massimo di organizzazioni",
    "fileAlreadyImported": "Questo file è già stato importato come documento",
    "invalidToken": "Richiesta non più valida",
    "passwordsDoNotMatch": "Le password non coincidono",
    "privateNetworkRequired": "Conferma che l'endpoint è su una rete privata",
    "refreshIntervalUrlOnly": "Solo le pagine web possono aggiornarsi da sole",
    "required": "Obbligatorio",
    "slugAlreadyExists": "Lo slug esiste già",
    "slugFormat": "Lo slug può contenere solo lettere minuscole, numeri e trattini (-)",
    "urlAlreadyImported": "Questo URL è già stato importato come documento",
    "syncSourceUrlOnly": "Solo una pagina web può appartenere a una sorgente web"
  },
  "externalProvider": {
    "domain": "Dominio email",
    "github": "GitHub",
    "google": "Google",
    "microsoft": "Microsoft Entra"
  },
  "feature": {
    "apiTools": "API Tools",
    "byok": "Modelli propri (BYOK)",
    "endpoints": "API Endpoints",
    "fileUpload": "Caricamento file",
    "gateway": "Modelli della piattaforma",
    "group": {
      "channels": "Canali e pubblicazione",
      "models": "Modelli",
      "tools": "Strumenti e dati"
    },
    "integrations": "Integrazioni",
    "legend": "Funzionalità",
    "mcpServers": "Server MCP",
    "subAgents": "Sotto-agenti",
    "teams": "Microsoft Teams",
    "voice": "Conversazione vocale",
    "whatsapp": "WhatsApp"
  },
  "gdprRetention": {
    "anonymousLabel": "Cancellazione utenti anonimi",
    "chatLabel": "Anonimizzazione chat",
    "defaultDays": "Predefinito: {count} giorno. | Predefinito: {count} giorni.",
    "defaultDisabled": "Predefinito: disattivato.",
    "legend": "Conservazione dei dati (GDPR)",
    "unitDays": "giorni"
  },
  "help": {
    "aiDescription": "Un modello AI analizza il file e genera una descrizione strutturale del contenuto. Utile per documenti con tabelle, grafici o layout complessi.",
    "aiDescriptionModel": "Il modello AI usato per generare la descrizione",
    "aiDescriptionPrompt": "Prompt utilizzato per generare la descrizione",
    "browserEngine": "Come viene caricata la pagina prima dell'estrazione",
    "documentFile": "Sono consentiti PDF, Word (.docx), file di testo (.txt, .md, .csv) e immagini (.png, .jpg, .webp, .gif)",
    "fetchBrowserEngine": "veloce, recupera l'HTML statico. Ideale per la maggior parte dei siti.",
    "followExternal": "Recupera link da domini diversi",
    "forceOcr": "Forza l'estrazione testo tramite OCR (Document Intelligence). Utile per PDF scansionati o quando l'estrazione normale produce risultati insufficienti.",
    "pages": "Specifica quali pagine processare. Lascia vuoto per processare tutte le pagine. L'estrazione avverrà tramite OCR (Document Intelligence).",
    "puppeteerBrowserEngine": "esegue JavaScript con un browser locale. Per pagine dinamiche o single-page.",
    "remoteBrowserEngine": "come Puppeteer, ma su un browser remoto. Aggira blocchi e rilevamento bot.",
    "useBrowserEngine": "Più lento, ma consente l'analisi di pagine dinamiche",
    "useExtractionStrategy": "Migliora l'estrazione dei dati con l'AI",
    "webSourceWatch": "Le pagine vanno in una nuova cartella «{name}». A ogni controllo la piattaforma cerca nel sito le pagine pubblicate dopo e le importa lì. Restano modificabili.",
    "webSourceRemoveMissing": "Per un sito tuo, la cui sitemap elenca tutto ciò che è pubblicato. Se ne mancano troppe in una volta non rimuove niente e chiede conferma."
  },
  "hint": {
    "agentModel": "Pre-selezionato alla creazione di un nuovo agente.",
    "agentOnOwnEndpoint": "Questo agente gira sull’endpoint della tua organizzazione.",
    "allowedDomains": "Cerca solo all'interno di questi domini.",
    "approvalChannels": "Un tool può chiedere conferma all'utente prima di eseguire: espandi il tool per attivarla. Via API o in esecuzioni schedulate la chiamata viene rifiutata.",
    "audience": "L'audience attesa del token JWT (aud). Se vuota, l'audience non viene verificata.",
    "blockedDomains": "Escludi questi domini dai risultati.",
    "channel": {
      "app": "L'agente è accessibile tramite la pagina pubblica dedicata.",
      "frontoffice": "L'agente è visibile nel pannello Frontoffice.",
      "widget": "L'agente è incorporabile nei siti web tramite embed script."
    },
    "channelAppDisabled": "Il canale App è disabilitato: il link diretto e l'iframe non funzioneranno.",
    "channelWidgetDisabled": "Il canale Widget è disabilitato: il codice embed e il loader non funzioneranno.",
    "costSourceEndpoint": "I modelli sull’endpoint della tua organizzazione: li fattura il tuo fornitore, qui il costo è una stima a prezzi di listino.",
    "customCss": "CSS iniettato nello shadow DOM del widget. Permette di personalizzare l'interfaccia della chat dall'esterno.",
    "disallowPromptTraining": "Instrada le richieste solo verso provider che non usano i dati per addestrare i modelli AI.",
    "dismissableNotice": "Verrà nascosto dopo il primo messaggio.",
    "documentFolderManaged": "Cartella sincronizzata da {provider}: il contenuto si modifica alla sorgente.",
    "documentRefresh": "Rilegge la pagina alla scadenza e rigenera solo ciò che è cambiato.",
    "documentRefreshTriggerOff": "Questa pagina si aggiorna da sola, e salvando un testo vostro si spegne.",
    "documentSelectionHasManaged": "La selezione contiene documenti che arrivano da una sorgente collegata e non si possono modificare a mano.",
    "documentSourceInterval": "Ogni quanto la cartella viene riletta. I file invariati non vengono riconvertiti.",
    "documentSourceName": "Il nome con cui la cartella compare qui. Quello remoto non cambia.",
    "emailClaim": "Il claim JWT che contiene l'email dell'utente (default: email).",
    "embedCode": "Copia e incolla questo codice per incorporare l'agente nel tuo sito web.",
    "embedding": "I vettori della base di conoscenza, dei file degli utenti e delle memorie. Si calcolano sul gateway AI della piattaforma, oppure sul tuo endpoint con uno dei due modelli ammessi.",
    "embeddingActivation": "Prima di salvare, l’endpoint calcola il vettore di una frase di prova, che viene confrontato con quello del modello: un modello diverso viene rifiutato. Passare a un altro modello ricalcola la base di conoscenza e le memorie, e finché non ha finito le ricerche trovano solo ciò che è già nel modello nuovo.",
    "embeddingEndpointModel": "L’id con cui il tuo endpoint serve il modello",
    "embeddingEndpointOff": "Accendi l’endpoint per calcolarci i vettori",
    "embeddingFamily": "Fra quelli che il tuo endpoint serve",
    "embeddingFamilyUnknown": "L’endpoint non lo dichiara: lo verifica il salvataggio",
    "embeddingModelsServed": "Il tuo endpoint serve anche questi. Non possono rispondere a un agente: quello con cui si calcolano i vettori si sceglie nella sezione Embedding.",
    "embeddingNotConfigured": "La base di conoscenza, le risposte corrette, le memorie e l’elaborazione dei documenti sono ferme, perché nessuno calcola i loro vettori. Attiva un modello di embedding sul tuo endpoint per farle ripartire.",
    "embeddingReindexing": "Finché la reindicizzazione non finisce, le ricerche nella base di conoscenza e nelle memorie trovano solo ciò che è già nel modello nuovo: risultati parziali, mai sbagliati. Non serve fare niente, e se si interrompe riparte da dove era arrivata.",
    "embeddingStopped": "L’endpoint che calcola i vettori è spento: la base di conoscenza, le risposte corrette, le memorie e l’elaborazione dei documenti sono ferme finché non lo riaccendi.",
    "embeddingWithoutEndpoint": "I vettori della base di conoscenza, dei file degli utenti e delle memorie si calcolano sul gateway AI della piattaforma. Collega il tuo endpoint per calcolarli lì.",
    "embedIframe": "Incorpora l'interfaccia della chat direttamente con un iframe.",
    "embedPreview": "L'agente sarà accessibile al seguente URL.",
    "embeddingWithoutEndpointOrGateway": "I vettori della base di conoscenza, dei file degli utenti e delle memorie non si calcolano: questa organizzazione non usa il gateway AI della piattaforma. Collega il tuo endpoint per calcolarli lì.",
    "embeddingWithoutGateway": "I vettori della base di conoscenza, dei file degli utenti e delle memorie. Questa organizzazione non usa il gateway AI della piattaforma, quindi si calcolano solo sul tuo endpoint, con uno dei due modelli ammessi.",
    "externalContextSchema": "Definisci quali dati contestuali il sito ospitante può inviare all'agente.",
    "externalContextSchemaToggle": "Abilita la ricezione di dati contestuali dal sito ospitante.",
    "feature": {
      "apiTools": "Gli agenti chiamano come tool le API dell’organizzazione.",
      "byok": "L’organizzazione collega un suo endpoint compatibile OpenAI e ne usa i modelli.",
      "endpoints": "Gli agenti rispondono via REST ad altri sistemi.",
      "fileUpload": "Gli utenti allegano file ai messaggi in chat.",
      "gateway": "I modelli del gateway AI, e con loro l’embedding della piattaforma, le utility e l’AI dei documenti che li usano.",
      "integrations": "Collegamenti a CRM e a sorgenti di documenti come SharePoint.",
      "mcpServers": "Gli agenti usano i tool di server MCP esterni.",
      "subAgents": "Un agente ne chiama un altro come tool.",
      "teams": "Gli agenti rispondono nelle chat di Teams.",
      "voice": "Gli agenti parlano con l’utente in tempo reale.",
      "whatsapp": "Gli agenti rispondono su WhatsApp Business."
    },
    "fallbackModels": "Modelli alternativi tentati in ordine se il modello primario non è disponibile.",
    "fieldMappingFallback": "Valore usato se il campo sorgente è vuoto o assente.",
    "fieldMappingSource": "Supporta percorsi annidati (es. metadata.urgency).",
    "fieldMappingTransformExtractDomainCompany": "Estrae il nome azienda dal dominio email (es. mario@acme.it → Acme). Ignora i provider gratuiti (gmail, outlook, ecc.).",
    "fieldMappingTransformJoinArray": "Unisce i valori di un array separandoli con virgola.",
    "fieldMappingTransformMapValues": "Sostituisce il valore usando la tabella di mappatura.",
    "fieldMappingTransformNone": "Copia il valore così com'è.",
    "fieldMappingTransformSplitFirstLast": "Divide il testo sugli spazi.",
    "fileUploadDisabledHint": "Il caricamento file non è abilitato per questo agente. Puoi abilitarlo nelle impostazioni dell'agente.",
    "fileUploadEnabled": "Permetti agli utenti di allegare file ai messaggi.",
    "freshnessBoost": "Applica un boost basandosi su quanto recentemente il documento è stato aggiornato.",
    "freshnessScale": "Scala temporale spinta (Giorni)",
    "freshnessScaleExplanation": "Il bonus si dimezza dopo {half} giorni e si azzera praticamente dopo {zero} giorni ({zero} mesi).",
    "freshnessScaleExplanationDays": "Un documento modificato oggi ottiene un bonus di +{weight}. Il bonus si dimezza a +{halfWeight} dopo {half} giorni e si azzera praticamente (+{zeroWeight}) dopo {zero} giorni.",
    "freshnessScaleExplanationMonths": "Un documento modificato oggi ottiene un bonus di +{weight}. Il bonus si dimezza a +{halfWeight} dopo {half} giorni e si azzera praticamente (+{zeroWeight}) dopo {zero} giorni (circa {months} mesi).",
    "freshnessScaleExplanationYears": "Il bonus si dimezza dopo {half} giorni e si azzera praticamente dopo {zero} giorni ({years} anni).",
    "freshnessScaleTooltip": "Il tempo di dimezzamento (half-life) del decadimento esponenziale. Un documento vecchio esattamente quanto questo valore riceverà il 50% del boost massimo. Più è basso, più i documenti vecchi perderanno rapidamente il boost.",
    "freshnessWeight": "Moltiplicatore del peso del boost di freschezza nella formula.",
    "freshnessWeightTooltip": "Bonus massimo aggiunto allo score per i documenti appena modificati. Un peso di 0.1 significa che un documento freschissimo otterrà un vantaggio di +0.10 sullo score. Questo vantaggio decadrà esponenzialmente col tempo fino a azzerarsi.",
    "gatewayCatalog": "I modelli messi a disposizione dalla piattaforma, con il prezzo per milione di token, la dimensione del contesto e le garanzie sulla riservatezza dei dati. Spegni quelli che la tua organizzazione non usa: escono dalla scelta, e un agente che ne usa ancora uno risponde con il modello predefinito.",
    "gatewayNotUsed": "Questa organizzazione non usa il gateway AI della piattaforma, quindi i suoi modelli non sono disponibili. Può riattivarlo l’operatore della piattaforma.",
    "gatewayOffDisconnected": "Se il suo endpoint non è acceso e con dei modelli, l’organizzazione è scollegata: nessun agente risponde.",
    "gatewayOffNoByok": "Anche i modelli propri (BYOK) sono spenti: l’amministratore non può né configurare un endpoint né accenderlo o spegnerlo, e nemmeno spostare l’embedding.",
    "gatewayOffStops": "Spento, niente di questa organizzazione passa più dal gateway, entro trenta secondi: i modelli del gateway smettono di rispondere, e con loro le utility interne che li usano; la ricerca web si ferma. La base di conoscenza, le risposte corrette, le memorie e l’elaborazione dei documenti continuano solo se l’embedding è sull’endpoint dell’organizzazione: se è sulla piattaforma, si fermano.",
    "gatewayOffTodo": "L’amministratore deve spostare sull’endpoint dell’organizzazione entrambi i modelli predefiniti, altrimenti non si creano agenti nuovi, e l’embedding (Modelli, sezione Embedding), altrimenti la base di conoscenza e le memorie restano ferme. L’inferenza non scala più il credito; i minuti di voce e l’OCR dei documenti sì.",
    "guaranteeAll": "{name}: garantita su tutti i provider.",
    "guaranteeNone": "{name}: non garantita.",
    "guaranteeSome": "{name}: garantita solo su alcuni provider, il gateway instrada di conseguenza.",
    "includeThoughts": "Invia i pensieri del modello al client insieme alla risposta.",
    "inputSchema": "JSON Schema (draft-07) dei parametri di input che l'LLM può fornire.",
    "integrationOAuthAdminConsent": "Potrebbe servire un amministratore Microsoft 365 della vostra organizzazione.",
    "integrationAppCredentialScope": "Con Sites.Read.All l'app può leggere ogni sito del tenant. Il connettore legge solo le cartelle che collegate.",
    "integrationAppCredentialSteps": "In Microsoft Entra ID: Registrazioni app, Nuova registrazione. Poi Autorizzazioni API, Microsoft Graph, Autorizzazioni applicazione, Sites.Read.All, e Concedi consenso amministratore. Poi Certificati e segreti, Nuovo segreto client (annotate la scadenza). Copiate qui l'ID directory (tenant), l'ID applicazione (client) e il valore del segreto.",
    "interactiveLogin": "Permette agli utenti anonimi di accedere dalla chat. L'external token resta sempre attivo.",
    "issuer": "L'URL dell'issuer del token JWT (iss).",
    "jwksUrl": "L'URL dell'endpoint JWKS per la verifica della firma JWT.",
    "loadDelay": "Millisecondi di attesa prima di iniettare il widget. Utile su pagine con loader AMD lenti (es. RequireJS).",
    "loaderStrategy": {
      "dynamic-import": "Usa import() all'interno di un <script> classico. Fallback per pagine dove gli script module sono bloccati o intercettati da loader legacy.",
      "inline-module": "Inietta un <script type=\"module\"> inline con un import statico. Bypassa RequireJS e altri loader AMD. Consigliata per la maggior parte dei siti.",
      "script-src": "Carica il bundle tramite <script type=\"module\" src=\"...\">. Usala su siti con Content Security Policy (CSP) restrittiva che blocca gli script inline."
    },
    "mcpServerHealthCheckPath": "L'endpoint utilizzato per verificare lo stato del Server MCP (es: /api/health).",
    "mcpStatelessServer": "Forza il client a connettersi in modalità stateless.",
    "mmr": "Bilancia la rilevanza semantica e la diversità dei documenti nei risultati di ricerca per evitare contenuti ridondanti.",
    "mmrCandidatesLimit": "Numero massimo di chunk candidati pre-selezionati prima di applicare l'MMR.",
    "mmrCandidatesLimitTooltip": "Quanti risultati pre-selezionare dal database prima di filtrare e diversificare. Esempio: se impostato a 100, il sistema cercherà i 100 chunk più pertinenti e poi estrarrà tra questi quelli più diversi tra loro fino a raggiungere il limite finale per la chat.",
    "mmrDiversity": "Tradeoff tra rilevanza (0.0) e diversità (1.0).",
    "mmrDiversityTooltip": "Determina quanto spazio dare a informazioni diverse. Un valore vicino a 0 predilige i risultati più pertinenti anche se simili tra loro. Un valore vicino a 1 forza l'inserimento di risultati con dettagli e temi differenti, riducendo la ripetitività.",
    "modelContextWindow": "Finestra di contesto: {count}k token.",
    "modelDefaultNoneAvailable": "Nessun modello disponibile: attiva almeno un modello del tuo endpoint qui sotto.",
    "modelDefaultOutsideCatalog": "Questo modello non è tra quelli disponibili per la tua organizzazione: scegline un altro. Nel frattempo i nuovi agenti partono con il modello standard della piattaforma.",
    "modelDefaults": "Valgono per tutta l'organizzazione. Ogni agente può comunque usare un modello diverso, scelto nelle sue impostazioni.",
    "modelDisabledForOrganization": "Spento per questa organizzazione: gli agenti che lo usano ancora rispondono con il modello predefinito, e non si può scegliere per uno nuovo.",
    "modelEndpointBaseUrl": "L'indirizzo base dell'API compatibile OpenAI.",
    "modelEndpointHttp": "Con http la chiave viaggia senza cifratura: usalo solo se l'endpoint è raggiungibile esclusivamente dalla tua rete interna.",
    "modelEndpointHttpTitle": "Connessione non cifrata (http)",
    "modelEndpointKey": "Viene salvata cifrata e non viene mai mostrata.",
    "modelEndpointKeyStored": "Già salvata. Lascia il campo vuoto per non cambiarla.",
    "modelEndpointName": "Il nome con cui lo riconoscerai nella scelta dei modelli.",
    "modelEndpointOffWithEmbedding": "Endpoint spento: i suoi modelli non sono disponibili, gli agenti che li usano smettono di rispondere, e con lui si fermano la base di conoscenza, le memorie e i documenti, perché calcola i loro vettori. Riaccendilo per farli ripartire.",
    "modelEndpointOnWithoutGateway": "Endpoint acceso: i modelli che attivi sono gli unici che gli agenti possono usare, perché questa organizzazione non usa il gateway della piattaforma, e possono essere i predefiniti.",
    "modelNotOnEndpoint": "Non disponibile per questa organizzazione: il suo endpoint non ha più questo modello, quindi un agente che lo usa non risponde finché non passa a un altro modello.",
    "modelSourceEndpoint": "Gira su {name}, l’endpoint della tua organizzazione: lo fattura il tuo fornitore, e i costi che vedi qui sono stimati dal listino.",
    "modelSourceOff": "Non disponibile per questa organizzazione: la sorgente su cui gira è spenta, quindi un agente che lo usa non risponde finché non passa a un altro modello o la sorgente non viene riaccesa.",
    "modelSourcePlatform": "Gira sul gateway AI della piattaforma e si paga con il credito della tua organizzazione.",
    "ownEndpoint": "Usa i tuoi modelli accanto a quelli della piattaforma: collega un endpoint compatibile con le API OpenAI e la tua chiave. Gli agenti che usano i suoi modelli non consumano il credito.",
    "modelEndpointOn": "Endpoint acceso: i modelli che attivi sono a disposizione degli agenti accanto a quelli della piattaforma, e possono essere i predefiniti.",
    "modelEndpointOff": "Endpoint spento: i suoi modelli non sono disponibili, e gli agenti che li usano smettono di rispondere. Attiva qui sotto i modelli che ti servono, poi accendilo.",
    "addModelsRule": "Attiva i modelli che i tuoi agenti potranno usare. Il prezzo viene preso dal listino della piattaforma; se un modello non è in listino, ti chiederemo di indicarlo.",
    "modelPriceAsk": "Questo modello non è nel listino della piattaforma. Scegli un modello del catalogo con un costo simile, oppure inserisci i prezzi per milione di token.",
    "modelPriceUnknown": "Non è nel listino della piattaforma: indica un prezzo.",
    "modelGuaranteedOnSome": "Le garanzie che hai acceso valgono solo su alcuni provider di questo modello: il gateway instrada di conseguenza.",
    "modelIdByHand": "Il nome tecnico con cui l'endpoint identifica il modello.",
    "modelNotCompatible": "Non compatibile con i flag di riservatezza di questo agente.",
    "modelPriceFromListing": "Prezzo preso da {id} nel listino della piattaforma.",
    "modelPriceListing": "Listino della piattaforma, voce {id}, aggiornato il {date}.",
    "modelPriceManual": "Prezzo inserito a mano il {date}.",
    "modelPriceReference": "Stesso prezzo di {id}, aggiornato il {date}.",
    "modelReference": "Un modello del catalogo a cui questo assomiglia.",
    "modelRetired": "Non più disponibile sulla piattaforma: sposta su un altro modello gli agenti che lo usano.",
    "moveDocument": "Scegli la cartella di destinazione per «{name}».",
    "moveDocuments": "Scegli la cartella di destinazione per {n} documento. | Scegli la cartella di destinazione per {n} documenti.",
    "multipleChoiceAllowCustomAnswer": "Mostra un campo di testo libero sotto le opzioni per consentire all'utente di inserire una risposta personalizzata.",
    "multipleChoiceMaxOptions": "Numero massimo di opzioni che l'AI può generare (min. 2, max. 10).",
    "nameClaim": "Il claim JWT che contiene il nome dell'utente (default: name). Se manca, il sistema prova name, given_name e family_name, e lo stesso namespace del claim email.",
    "oauthCallbackUrl": "Configura questa URL come Callback URL (Redirect URI) nel provider OAuth.",
    "outputSchema": "JSON Schema (draft-07) della risposta attesa. Solo documentativo.",
    "passphrase": "Inserisci {passphrase} per confermare l'operazione",
    "platformSupported": "Resa nativa su WhatsApp e Teams",
    "privacyPolicyNotice": "Visibile del modulo di contatto.",
    "providerOrganizationId": "Per Microsoft si riferisce all'identificativo del tenant (tenant ID). Per gli altri inserire il dominio dell'e-mail (es. company.com).",
    "providerTimeoutMs": "Timeout in millisecondi prima di passare al provider successivo (min 1000, max 789000). Solo credenziali BYOK.",
    "reasoningDefault": "Valore predefinito della piattaforma, si applica finché non scegli un valore diverso.",
    "reasoningNotSupported": "Il reasoning non è supportato per il provider selezionato.",
    "sessionExpiresIn": "Durata della sessione widget in secondi (min 60). Se vuoto vale il default di 8 ore.",
    "showExtendedSteps": "Visualizza la timeline con il ragionamento e gli strumenti nella chat.",
    "smoothStream": "Uniforma lo streaming del testo creando un'esperienza di lettura più naturale.",
    "subAgentName": "Sono consentiti solo lettere, numeri, underscore (_) e trattini (-).",
    "teamsAccentColor": "Per impostazione predefinita usa il colore del tema dell'agente.",
    "teamsAppVersion": "Incrementala (es. 1.0.1) e reinstalla il pacchetto per applicare le modifiche al manifest, come i nuovi permessi, alle app già installate.",
    "tool": {
      "fetchTeamsChannelHistory": "Sui canali Teams, permette all'agente di leggere su richiesta la conversazione più ampia del canale. Richiede la reinstallazione dell'app Teams.",
      "geocode": "Converte nomi di luoghi in coordinate geografiche e viceversa.",
      "getWeather": "Recupera i dati meteo attuali e le previsioni per una località specifica.",
      "readDocumentFile": "Permette all'agente di leggere il file originale dei documenti PDF/DOCX dalla knowledge base. Utile per tabelle, grafici e contenuti visivi.",
      "requestGeolocation": "Richiede la posizione GPS dell'utente tramite il browser.",
      "retrieveRevisedAnswers": "Recupera le risposte verificate dagli amministratori e le usa come fonte primaria.",
      "runWorker": "Permette all'agente di avviare worker generici che ereditano i suoi tool per gestire sotto-attività indipendenti in parallelo.",
      "searchInKnowledgeBase": "Cerca nei documenti caricati nella knowledge base per fornire risposte contestuali.",
      "searchInUserFiles": "Cerca nei file che l'utente ha caricato personalmente in chat (i suoi file privati), separati dalla knowledge base dell'agente.",
      "showArtifact": "Mostra contenuti strutturati come testi formattati, codice o documenti.",
      "showCalendarEvent": "Mostra un evento calendario con opzioni per Google Calendar, Outlook e download .ics.",
      "showComparison": "Confronta da 2 a 4 elementi affiancati per facilitare la scelta.",
      "showContactForm": "Mostra un modulo di contatto per raccogliere i dati dell'utente.",
      "showDiagram": "Mostra un grafico o un diagramma (flusso, sequenza, classe, ER, stato).",
      "showEmail": "Compone un'email pronta da inviare dal client di posta dell'utente.",
      "showForm": "Permette di raccogliere input strutturati (testo, numeri, date, scelte) tramite form multi-step.",
      "showImageGallery": "Raccoglie le immagini in una galleria navigabile con zoom e lightbox.",
      "showLocation": "Mostra una mappa interattiva con segnaposto e indicazioni stradali.",
      "showMessage": "Compone un messaggio da inviare tramite WhatsApp, Telegram o SMS.",
      "showMultipleChoice": "Propone opzioni selezionabili per guidare il flusso della conversazione.",
      "showProductList": "Mostra un elenco di prodotti con immagini, descrizioni e link d'acquisto.",
      "showQrCode": "Genera un codice QR a partire da testo, URL o dati strutturati.",
      "showSources": "Mostra i riferimenti ai documenti della knowledge base utilizzati nella risposta.",
      "showSuggestedReply": "Suggerisce risposte cliccabili per proseguire la conversazione. Per averle dopo ogni risposta, chiedilo nelle istruzioni dell'agente.",
      "showVideo": "Riproduce video inline: file diretti (MP4/WebM) o link YouTube/Vimeo.",
      "showWeather": "Mostra un widget con le previsioni meteo direttamente nella chat.",
      "showWebPages": "Suggerisce link a pagine web pertinenti alla domanda dell'utente.",
      "useAllUserFiles": "Cerca in tutti i file dell'utente, anche quelli caricati su altri agenti, non solo in quelli di questo agente.",
      "useAllUserKb": "Legge le memorie che l'utente ha condiviso con tutti gli agenti di questa organizzazione, non solo con questo. La scrittura resta legata a questo agente.",
      "userMemory": "Permette all'agente di ricordare e richiamare informazioni che l'utente condivide tra le conversazioni (nome, preferenze, ecc.)."
    },
    "toolRequiresApproval": "Prima di eseguire, l'assistente attende l'approvazione in chat.",
    "apiToolSecretParameters": "Inviati a ogni chiamata, nella query string o nel body JSON, e mai mostrati al modello. Dopo il salvataggio il valore non si vede più: lascialo vuoto per tenerlo.",
    "apiToolSecretParametersNew": "Inviati a ogni chiamata, nella query string o nel body JSON, e mai mostrati al modello. Scrivi ogni valore: dopo il salvataggio non si vede più.",
    "apiToolSecretStored": "Salvato: lascialo vuoto per tenerlo",
    "apiToolCredentialInSchema": "Questi parametri sembrano credenziali, e li compila il modello: {names}. Spostali fra i parametri segreti e toglili dallo schema di input.",
    "apiToolCredentialBadge": "Un parametro che sembra una credenziale viene compilato dal modello",
    "apiToolSecretsOriginChanged": "L'URL punta a un altro host: riscrivi i valori dei parametri segreti, quelli salvati restano legati all'host precedente.",
    "apiToolSecretBodyMethod": "Una richiesta {method} non ha body",
    "toolWorkingSetMode": {
      "active": "Prima di ogni risposta un modello di valutazione (TypeSafe Jev) sceglie i server MCP, gli API Tools e i sotto-agenti che servono al messaggio, e l’agente vede solo quelli. Se gliene serve un altro, lo riattiva da solo. Ogni valutazione è addebitata all’organizzazione.",
      "off": "L’agente vede tutti i tool a ogni risposta.",
      "shadow": "Il modello di valutazione sceglie i tool che servono a ogni messaggio, ma l’agente li vede comunque tutti: la scelta viene solo registrata nel dettaglio del messaggio, per confrontarla con i tool usati davvero prima di attivarla. Ogni valutazione è addebitata all’organizzazione."
    },
    "useColorsForAgentHeader": "Colora l'intestazione dell'agente in base al colore principale.",
    "userFeedbackComment": "L'utente ha lasciato un commento su questa risposta",
    "userFeedbackNegative": "L'utente ha valutato negativamente questa risposta",
    "userFeedbackPositive": "L'utente ha valutato positivamente questa risposta",
    "userFeedbackReaction": "L'utente ha reagito a questa risposta",
    "utilityModel": "Usato dietro le quinte per compiti come riformulare le domande degli utenti e aggiornare le memorie.",
    "voiceApprovalRefused": "Durante una chiamata queste azioni non partono: l'approvazione si dà a schermo e al telefono non c'è nessuno a cui chiederla, quindi l'agente le rifiuta e lo dice. Riguarda: {tools}.",
    "voiceCascadeTimeoutSeconds": "Quanto il fornitore aspetta noi prima di annullare il turno. Deve stare sopra al turno più lento dell'agente: knowledge base, tool e modelli lenti lo allungano.",
    "voiceEnabled": "Permette di parlare con questo agente. La risposta resta sua, con la sua knowledge base e i suoi strumenti.",
    "voiceFillerAfterSeconds": "Dice che sta lavorando quando la risposta tarda. Vuoto: quattro secondi.",
    "voiceFillerMessage": "Scrivila in modo che ogni continuazione suoni naturale. Vuoto: una frase predefinita nella lingua della voce.",
    "voiceFirstMessage": "Detta appena si apre la chiamata. Copre anche il primo turno, il più lento.",
    "voiceId": "Le voci clonate non sono in elenco: il fornitore non le ammette qui.",
    "voiceIgnoreBackgroundVoices": "Ascolta solo chi parla. Da tenere attivo dove il microfono sente la stanza.",
    "voiceLanguage": "Usata per riconoscere il parlato e per parlare.",
    "voiceMaxSessionSeconds": "Una chiamata si paga a minuto e si chiude da sola a questo limite.",
    "voiceRemaining": "Tempo che resta in questa chiamata",
    "voiceSlowAgentOnCall": "Una knowledge base grande o server MCP collegati possono far metterci diversi secondi all'agente, e in chiamata quei secondi sono silenzio: le due impostazioni qui sotto sono ciò che tiene compagnia a chi chiama mentre lavora. Se le chiamate sembrano lente, la risposta si accorcia anche con meno passi, un limite di retrieval più basso o un modello più rapido.",
    "voiceTurnEagerness": "Pronto risponde prima ma ti taglia sulle pause; paziente aspetta che tu finisca.",
    "voiceTurnTimeoutSeconds": "Quanto l’agente aspetta il chiamante zitto prima di riprendere la parola. Niente a che vedere con la sua velocità di risposta.",
    "webSearchEnabled": "Permetti all'agente di cercare informazioni sul web durante le conversazioni.",
    "webSearchNative": "Usa le funzionalità di ricerca web integrate di {provider}.",
    "webhookUrl": "Incolla questo URL nella configurazione del webhook / endpoint di messaggistica della piattaforma.",
    "welcomePopup": "Mostra un popup di benvenuto con il messaggio iniziale prima che la chat venga aperta.",
    "whatsappVerifyToken": "Incolla questo token nella configurazione webhook di Meta.",
    "zeroDataRetention": "Instrada le richieste solo verso provider con accordi ZDR. Restringe il pool di provider disponibili.",
    "webSourceUnselected": "Le pagine non selezionate arriveranno con i prossimi controlli della sorgente.",
    "webSourceInterval": "Le pagine nuove, una volta importate, vengono rilette con la frequenza qui sopra come le altre.",
    "webPagesRefresh": "Alla scadenza ogni pagina viene riletta e si rigenera solo ciò che è cambiato. Con «Manuale» resta com'è finché non la aggiorni tu.",
    "documentFolderWebSource": "Cartella di un sito web: le pagine nuove arrivano da sole e restano modificabili."
  },
  "integrationProvider": {
    "hubspot": "HubSpot",
    "salesforce": "Salesforce",
    "sharepoint": "SharePoint",
    "web": "Sito web"
  },
  "integrationProviderDescription": {
    "hubspot": "Sincronizza i contatti con HubSpot CRM.",
    "salesforce": "Sincronizza i contatti con Salesforce CRM.",
    "sharepoint": "Collega una cartella di SharePoint: i file entrano nella knowledge base e restano aggiornati da soli."
  },
  "integrationSyncStatus": {
    "failed": "Fallito",
    "pending": "In attesa",
    "success": "Successo"
  },
  "interval": {
    "D": "giorno | giorni",
    "M": "mese | mesi",
    "W": "settimana | settimane",
    "Y": "anno | anni"
  },
  "invitationStatus": {
    "accepted": "Accettato",
    "canceled": "Annullato",
    "expired": "Scaduto",
    "pending": "In attesa"
  },
  "label": {
    "AI": "AI",
    "acceptInvitationAndCreateAccount": "Accetta l'invito e crea il tuo account",
    "accountingCredit": "Saldo contabile",
    "actions": "Azioni",
    "active": "Attiva",
    "activeSessions": "Sessioni attive",
    "actualCost": "Costo reale",
    "addApiTool": "Aggiungi API Tool",
    "addIntegration": "Aggiungi integrazione",
    "additionalMetadata": "Metadati aggiuntivi",
    "admin": "Amministratore",
    "advancedOptions": "Opzioni avanzate",
    "agent": "Agente",
    "agentModel": "Modello di default",
    "agentResponse": "Risposta agente",
    "agentTree": "Albero Agente",
    "agents": "Agenti",
    "agentsUsed": "Agenti utilizzati",
    "aiDescription": "Generato con AI",
    "aiDescriptionModel": "Modello AI",
    "aiDescriptionPrompt": "Prompt personalizzato",
    "allAgents": "Tutti gli agenti",
    "allChannels": "Tutti i canali",
    "allowedDomains": "Domini consentiti",
    "analysis": "Analisi",
    "analyzed": "Analisi",
    "anonymized": "Anonimizzata",
    "anonymous": "Anonimo",
    "answer": "Risposta",
    "answeringOnTheCall": "Sto rispondendo…",
    "apiKey": "API Key",
    "apiKeys": "API Key",
    "appearance": "Aspetto",
    "arrayOfObjects": "Array di oggetti",
    "assistantMessage": "Risposta assistente",
    "attachmentsNotImported": "Allegati non importati",
    "attempts": "Tentativi",
    "attention": "Attenzione",
    "audience": "Audience",
    "authentication": "Autenticazione",
    "auto": "Auto",
    "autoDetected": "Rilevati automaticamente",
    "autoProvisioning": "Auto provisioning",
    "autoProvisioningDescription": "Gli utenti che si autenticano tramite questi provider di identità o domini verranno automaticamente aggiunti alla tua organizzazione con il ruolo predefinito.",
    "autoRefreshError": "Errore",
    "autoRefreshOff": "In pausa",
    "autoRefreshOn": "Live",
    "autoRefreshStoppedErrors": "Aggiornamento automatico interrotto dopo errori ripetuti.",
    "autoRefreshStoppedUnavailable": "Aggiornamento automatico interrotto: questo contenuto non è più accessibile.",
    "autoRefreshWarning": "Attenzione",
    "availableCredit": "Saldo disponibile",
    "averageLine": "Media",
    "avgChatsPerUser": "Chat per user",
    "avgMessagesPerChat": "Messaggi per chat",
    "avgTime": "Tempo medio",
    "banned": "Bannato",
    "baseUrl": "URL di base",
    "black": "Nero",
    "blocked": "Bloccato",
    "blockedDomains": "Domini bloccati",
    "blockedReasons": "Motivi di blocco",
    "body": "Testo",
    "botName": "Nome bot",
    "breadcrumbs": "Percorso di navigazione",
    "browserEngine": "Browser engine",
    "browsers": "Browser",
    "budgetTokens": "Budget token",
    "byChannel": "Per canale",
    "cached": "dalla cache",
    "calendarEvent": "Evento",
    "changePassword": "Cambia Password",
    "channel": "Canale",
    "channels": "Canali",
    "chat": "Chat",
    "chatCreatedAgo": "Creata",
    "chatOrigin": "Chat di origine",
    "chatStatistics": "Statistiche",
    "chatTypes": "Tipo di conversazione",
    "chatUpdatedAgo": "Ultimo messaggio",
    "chatWidget": "Chat Widget",
    "chunks": "Chunk",
    "clear": "Pulisci",
    "codeEditor": "Codice",
    "collapseContext": "Nascondi contesto",
    "comment": "Commento",
    "comparison": "Confronto",
    "completeName": "Nome e cognome",
    "completedAt": "Completata il",
    "configMcpServer": "Configura server MCP",
    "configure": "Configura",
    "confirm": "Conferma",
    "confirmPassword": "Conferma password",
    "confirmPrivateNetwork": "Confermo che l’endpoint non è raggiungibile da Internet",
    "confirmWithEmail": "Digita la tua email per confermare",
    "confirmWithPassword": "Inserisci la password per confermare",
    "connectMcpServer": "Connetti server MCP",
    "connectSubAgent": "Collega sotto-agente",
    "connectedAccounts": "Account collegati",
    "connectedIntegrations": "Integrazioni collegate",
    "connectionChecking": "Verifica connessione...",
    "connectionConnected": "Connesso",
    "connectionError": "Errore di connessione",
    "connectionIdle": "Non verificato",
    "connectionStatus": "Connessione",
    "connectionTypes": "Connessione",
    "const": "Costante",
    "contactUs": "Contattaci",
    "content": "Contenuto",
    "contentPreview": "Anteprima contenuto",
    "contextTokens": "{count}k contesto",
    "conversationLengthBuckets": "Lunghezza conversazione",
    "conversationOutline": "Indice della conversazione",
    "conversations": "Conversazioni",
    "conversationsOverTime": "Conversazioni nel tempo",
    "cost": "Costo",
    "costByChannel": "Costo per canale",
    "costInUSD": "Costo in USD",
    "costSource": "Sorgente del costo",
    "costSourceAll": "Totale",
    "costSourceEndpoint": "Endpoint",
    "costSourceGateway": "Gateway",
    "country": "Paese",
    "crawlMode": "Modalità Crawling",
    "createdAt": "Creato il",
    "createdBy": "Creato da",
    "credit": "Credito",
    "creditUpdatedAt": "Credito aggiornato il",
    "credits": "Crediti",
    "crmSync": "Sincronizzazione CRM",
    "curlExample": "Esempio cURL",
    "currentAgent": "Agente corrente",
    "currentLocation": "Posizione attuale",
    "currentPassword": "Password attuale",
    "currentSession": "Sessione corrente",
    "customCss": "CSS personalizzato",
    "customRange": "Personalizzato",
    "dailyUsage": "Utilizzo giornaliero",
    "dark": "Scuro",
    "darkModePreference": "Tema scuro",
    "dataLoadFailed": "Non è stato possibile caricare questo dato",
    "datetime": "Data / Ora",
    "day": "Giorno",
    "dayRateLimit": "Limite al giorno",
    "days": "{count} giorno | {count} giorni",
    "default": "Predefinito",
    "defaultMappingHint": "Se non viene configurata una mappatura, verrà utilizzata quella predefinita per il provider.",
    "defaultRole": "Ruolo predefinito",
    "deleted": "Eliminato",
    "deprecated": "Deprecato",
    "description": "Descrizione",
    "deselectAction": "Rimuovi",
    "details": "Dettagli",
    "device": "Dispositivo",
    "deviceContext": "Contesto dispositivo",
    "deviceType": "Tipo dispositivo",
    "diagram": "Diagramma",
    "disabled": "Disabilitato",
    "disallowPromptTraining": "Prompt Training disabilitato",
    "dismissableNotice": "Avviso",
    "documentOrigin": "Origine",
    "documentPriority": "Priorità Documento",
    "documentRefresh": "Aggiornamento automatico",
    "documentRefreshAuto": "Automatico",
    "documentRefreshInterval": "Frequenza",
    "documentRefreshLastRead": "Ultima lettura",
    "documentRefreshNext": "Prossimo aggiornamento",
    "documentRefreshOutcome": "Esito",
    "documentRefreshPaused": "In pausa",
    "documentSourceInterval": "Frequenza di controllo",
    "documentSourceLastRun": "Ultima esecuzione",
    "documentSourceLastSync": "Ultimo controllo",
    "documentSourceNextSync": "Prossimo controllo",
    "documentSourceSearch": "Cerca un sito",
    "documentType": "Tipo documento",
    "documents": "Documenti",
    "domainFilter": "Filtro domini",
    "downloadFile": "Scarica file",
    "downloading": "Download in corso",
    "duration": "Durata",
    "editApiTool": "Modifica API Tool",
    "editIntegration": "Modifica integrazione",
    "editMcpServer": "Modifica server MCP",
    "editSubAgent": "Modifica sotto-agente",
    "effectiveCredit": "Credito effettivo",
    "email": "Email",
    "emailClaim": "Claim email",
    "emailDomain": "Dominio email",
    "emailVerified": "Email verificata",
    "embed": "Incorpora",
    "embedCode": "Codice Embed",
    "embedding": "Embedding",
    "embeddingEndpointModel": "Id sull’endpoint",
    "embeddingModel": "Modello di embedding",
    "embeddingModelsCount": "Modelli di embedding ({count})",
    "embeddingNotConfigured": "Non configurato",
    "embeddingNotConfiguredReason": "Il gateway AI della piattaforma è spento per questa organizzazione",
    "embeddingOnEndpoint": "Embedding sul tuo endpoint",
    "embeddingOnPlatform": "Sul gateway AI della piattaforma",
    "embeddingReindex": "Reindicizzazione della base di conoscenza e delle memorie",
    "embeddingReindexDone": "Reindicizzato il {date}",
    "embeddingReindexPaused": "Reindicizzazione in pausa",
    "embeddingReindexProgress": "Reindicizzazione: {done} vettori su {total}",
    "embeddingReindexQueued": "Reindicizzazione in coda: parte entro pochi minuti",
    "enabled": "Abilitato",
    "enabledTools": "Tool abilitati",
    "endDate": "Data fine",
    "endpointCost": "Costo endpoint (stima)",
    "endpointModels": "Modelli del tuo endpoint",
    "engagement": "Engagement",
    "enum": "Valori enum",
    "error": "Errore",
    "estimatedCost": "Costo stimato a fine mese",
    "estimatedCredit": "Credito stimato",
    "estimatedMonthlyCost": "Stima fine mese",
    "excludeDomains": "Domini esclusi",
    "expandContext": "Mostra più contesto",
    "expireIn": "Scade tra",
    "expires": "Scade",
    "expiresAt": "Scadenza",
    "exportMyData": "Esporta i miei dati",
    "externalAuth": "Autenticazione esterna",
    "externalAuthDescription": "Configura i provider di autenticazione esterna per consentire l'autenticazione tramite token JWT emessi da questi provider. Gli utenti autenticati tramite questi provider saranno aggiunti automaticamente alla tua organizzazione con il ruolo predefinito (auto provisioning).",
    "externalContext": "Contesto esterno",
    "externalContextSchema": "Schema contesto esterno",
    "externalId": "ID esterno (CRM)",
    "fallbackModels": "Modelli di fallback",
    "feedback": "Segnalazione",
    "feedbacks": "Feedback",
    "fieldMappingFallback": "Valore di default",
    "fieldMappingSource": "Campo sorgente",
    "fieldMappingTarget": "Campo destinazione {number}",
    "fieldMappingTransform": "Trasformazione",
    "fieldMappingTransformExtractDomainCompany": "Estrai azienda da dominio email",
    "fieldMappingTransformJoinArray": "Unisci array",
    "fieldMappingTransformMapValues": "Mappa valori",
    "fieldMappingTransformNone": "Nessuna",
    "fieldMappingTransformSplitFirstLast": "Dividi primo/ultimo",
    "fieldMappingValueMap": "Mappatura valori",
    "file": "File",
    "fileUpload": "Caricamento file",
    "fileUploadAllowedMimeTypes": "Tipi di file consentiti",
    "fileUploadEnabled": "Abilita caricamento file",
    "fileUploadMaxFileSize": "Dimensione massima file (MB)",
    "fileUploadMaxFilesPerChat": "File massimi per chat",
    "fileUploadMaxFilesPerMessage": "File massimi per messaggio",
    "files": "File",
    "filters": "Filtri",
    "floatingButtonPosition": "Posizione bottone",
    "folderName": "Nome cartella",
    "folders": "Cartelle",
    "followExternal": "Segui Link Esterni",
    "footer": "Footer",
    "forceOcr": "Forza OCR",
    "formMaxOptionsPerStep": "Opzioni massime consigliate",
    "formMaxSteps": "Step massimi consigliati",
    "frequencyPenalty": "Penalità di Frequenza",
    "freshnessBoost": "Boost Freschezza",
    "freshnessScale": "Scala temporale Freschezza",
    "freshnessWeight": "Peso Freschezza",
    "fullDuration": "Durata (ms)",
    "gallery": "Galleria ({count} immagini)",
    "gatewayCost": "Costo gateway",
    "gatewayModels": "Modelli della piattaforma",
    "gdprRequestType": {
      "conversations_erasure": "Cancellazione conversazioni",
      "erasure": "Cancellazione dati",
      "export": "Export dati"
    },
    "gdprRequests": "Richieste GDPR",
    "general": "Generale",
    "generateSchemaFromJson": "Genera schema da JSON",
    "goalOutcome": "Esito obiettivo",
    "granularity": "Granularità",
    "groupReasoningAgents": "Raggruppa",
    "hasRedundantChunks": "Ha Chunk Ridondanti",
    "header": "Header",
    "headers": "Header HTTP",
    "healthCheckPath": "Health check",
    "hour": "Ora",
    "hourRateLimit": "Limite all'ora",
    "hsAccessToken": "Access Token",
    "hsAccessTokenHint": "Crea una Private App di HubSpot con i seguenti scope: crm.objects.contacts.read, crm.objects.contacts.write, crm.objects.owners.read.",
    "hsDefaultOwnerId": "Owner ID predefinito",
    "hsDefaultOwnerIdHint": "ID utente HubSpot a cui assegnare i contatti. Lasciare vuoto per non assegnare un owner.",
    "hsStaticProperties": "Proprietà statiche",
    "hsStaticPropertiesHint": "Proprietà fisse aggiunte ad ogni contatto.",
    "httpHeaderKey": "Chiave",
    "httpHeaderValue": "Valore",
    "secretParameters": "Parametri segreti",
    "secretParameterPosition": "Inviato in",
    "secretPositionQuery": "Query string",
    "secretPositionBody": "Body",
    "apiToolCredentialBadge": "Chiave esposta",
    "httpHeaders": "Header HTTP",
    "iframe": "Iframe",
    "iframeCode": "Codice iframe",
    "imageLoadError": "Immagine non disponibile",
    "impersonated": "Impersonificato",
    "impersonation": "Impersonificazione",
    "importing": "Importazione in corso",
    "inRedis": "In Redis",
    "inStock": "Disponibile",
    "integrationReconnectNeeded": "Da riconnettere",
    "integrationAppCredential": "App {clientId}",
    "modelDefaults": "Modelli predefiniti",
    "modelNotAvailable": "non disponibile",
    "modelSourcePlatform": "Piattaforma",
    "modelSwitchedOff": "spento",
    "ownEndpoint": "Il tuo endpoint (BYOK)",
    "price": "Prezzo",
    "priceListModel": "Modello del listino",
    "priceToSet": "Prezzo da indicare",
    "modelPriceOf": "Prezzo di {id}",
    "context": "Contesto",
    "someProviders": "Alcuni provider",
    "modelsActiveSummary": "{active} modelli attivi su {count}",
    "noModelsYet": "Ancora nessun modello",
    "notServedAnyMore": "Non più offerto dall'endpoint",
    "modelIdByHand": "Id del modello",
    "modelReference": "Modello di riferimento",
    "msClientId": "ID applicazione (client)",
    "msClientSecret": "Client secret",
    "msTenantId": "ID directory (tenant)",
    "inTest": "In test",
    "includeDomains": "Domini inclusi",
    "includeThoughts": "Visualizza ragionamento",
    "indexStatus": "Stato indicizzazione",
    "info": "Info",
    "initialMessage": "Messaggio iniziale",
    "input": "Input",
    "inputSchema": "Schema di Input",
    "insertEmail": "Inserisci email",
    "integration": "Integrazione",
    "integrationConfig": "Configurazione",
    "integrationDisabled": "Disabilitata",
    "integrationEnabled": "Abilitata",
    "integrationFieldMapping": "Mappatura campi",
    "integrationProvider": "Provider",
    "integrationSyncLogs": "Log sincronizzazione",
    "integrationSyncLogsDescription": "La sincronizzazione avviene automaticamente alla creazione di un nuovo contatto.",
    "integrations": "Integrazioni",
    "interactiveLogin": "Mostra login/registrazione",
    "interface": "Interfaccia",
    "invitations": "Inviti",
    "ipAddress": "Indirizzo IP",
    "isAutoJoinEnabled": "Unisci automaticamente utenti già presenti con la stessa e-mail",
    "issuer": "Issuer",
    "itemsPerPage": "Per pagina",
    "jsonSample": "Esempio JSON",
    "jwksUrl": "JWKS URL",
    "key": "Chiave",
    "language": "Lingua",
    "languages": "Lingue",
    "last14Days": "Ultimi 14 giorni",
    "last30Days": "Ultimi 30 giorni",
    "last7Days": "Ultimi 7 giorni",
    "last90Days": "Ultimi 90 giorni",
    "lastActive": "Ultimo accesso",
    "lastActivity": "Ultima attività",
    "lastMonth": "Mese scorso",
    "lastRecalledAt": "Ultimo richiamo",
    "lastReconciledAt": "Ultimo allineamento",
    "lastRefillAt": "Ultima ricarica il",
    "lastSync": "Aggiornato il",
    "lastUsedAt": "Ultimo utilizzo",
    "latest": "Ultima",
    "leadId": "ID interno",
    "left": "Sinistra",
    "light": "Chiaro",
    "limit": "Limite",
    "limitedStock": "Ultimi pezzi",
    "linkedAgents": "Agenti collegati",
    "llmIssues": "Problemi LLM",
    "loadDelay": "Ritardo caricamento (ms)",
    "loaderStrategy": "Strategia di caricamento",
    "loaderStrategyDynamicImport": "Dynamic Import",
    "loaderStrategyInlineModule": "Inline Module",
    "loaderStrategyScriptSrc": "Script Src",
    "locale": "Lingua",
    "location": "Posizione",
    "logo": "Logo",
    "logoUrl": "Logo URL",
    "mainColor": "Colore principale",
    "manageProfileDescription": "Modifica nome, password, avatar e altro",
    "maxDepth": "Profondità Massima",
    "maxMessageLength": "Lunghezza massima messaggio",
    "maxOutputTokens": "Token Massimi",
    "maxPages": "Pagine Massime",
    "maxResults": "Risultati massimi",
    "maxStepCount": "Numero Massimo di Step",
    "maxUses": "Utilizzi massimi",
    "mcpAuthType": "Tipo di autenticazione",
    "mcpServer": "Server MCP",
    "mcpServerUrl": "URL del server MPC",
    "mcpStatelessServer": "Client stateless",
    "memberSince": "Membro dal",
    "memories": "Memorie",
    "memory": "Memoria",
    "message": "Messaggio",
    "messageDetails": "Dettaglio messaggio",
    "messagePlaceholder": "Segnaposto",
    "messages": "Messaggi",
    "metadata": "Metadati",
    "method": "Metodo",
    "mimeTypeDocuments": "Documenti",
    "mimeTypeImages": "Immagini",
    "mimeTypeText": "Testo",
    "minuteRateLimit": "Limite al minuto",
    "mmr": "Maximal Marginal Relevance (MMR)",
    "mmrCandidatesLimit": "Limite Candidati MMR",
    "mmrDiversity": "Diversità MMR",
    "model": "Modello",
    "modelParameters": "Parametri modello",
    "month": "Mese",
    "monthRateLimit": "Limite al mese",
    "monthlyCost": "Costo mensile",
    "multipleChoiceAllowCustomAnswer": "Consenti risposta personalizzata",
    "multipleChoiceMaxOptions": "Numero massimo di opzioni",
    "name": "Nome",
    "nameClaim": "Claim nome",
    "never": "Mai",
    "newChat": "Nuova chat",
    "newPassword": "Nuova password",
    "no": "No",
    "noDataAvailable": "Nessun dato disponibile",
    "noDataRetention": "ZDR",
    "noFieldMapping": "Nessuna mappatura personalizzata configurata",
    "noIntegrations": "Nessuna integrazione configurata",
    "noPromptTraining": "No training",
    "noSyncLogs": "Nessun log di sincronizzazione",
    "noTimingData": "Nessun dato. Effettua una richiesta di chat per vedere i log di timing.",
    "noTimingDataDesc": "Avvia una conversazione con un agente per vedere i log di timing qui in tempo reale.",
    "noTimingDataTitle": "Nessun dato disponibile",
    "notAvailable": "Non disponibile",
    "notCompatible": "non compatibile",
    "notConfigured": "Non configurata",
    "notConnected": "Non connesso",
    "notSynced": "Non sincronizzata",
    "notificationTitle": {
      "document_error": "Elaborazione documento fallita",
      "document_sync_removed": "Documenti rimossi da una cartella sincronizzata",
      "organization": {
        "created": "Organizzazione creata",
        "invite": "Invito organizzazione",
        "invite_accepted": "Invito accettato",
        "invite_rejected": "Invito rifiutato",
        "removed": "Rimosso dall'organizzazione"
      },
      "password_reset_requested": "È stata richiesta la reimpostazione della password",
      "two_factor": {
        "enabled": "Verifica in due passaggi attivata",
        "disabled": "Verifica in due passaggi disattivata",
        "app": "La verifica in due passaggi usa un'app",
        "reset": "Verifica in due passaggi reimpostata",
        "passkeyAdded": "Passkey aggiunta",
        "passkeyRemoved": "Passkey rimossa",
        "unlocked": "Verifica in due passaggi sbloccata",
        "passkeyRemovedByAdmin": "Passkey rimossa da un amministratore",
        "trustedDevicesForgotten": "Dispositivi fidati dimenticati"
      },
      "web_source_pages_removed": "Pagine rimosse perché uscite dalla sitemap",
      "web_source_removal_held": "Pagine uscite dalla sitemap non rimosse"
    },
    "notificationType": {
      "api_key_expiring": "Scadenza API Key",
      "chat_blocked": "Chat bloccata",
      "chat_warning": "Avviso chat",
      "document_error": "Errore documento",
      "document_sync_removed": "Contenuti sincronizzati rimossi",
      "generic": "Generica",
      "organization": "Organizzazione",
      "password_reset_requested": "Reset password richiesto",
      "two_factor": "Sicurezza dell'accesso",
      "web_source_pages_removed": "Pagine uscite dalla sitemap",
      "web_source_removal_held": "Rimozione da confermare"
    },
    "oauthAuthorizationUrl": "URL di autorizzazione OAuth",
    "oauthClientId": "OAuth Client ID",
    "oauthClientSecret": "OAuth Client Secret",
    "oauthScopes": "Scopes OAuth",
    "oauthTokenUrl": "URL token OAuth",
    "ocrUsed": "OCR",
    "older": "Più vecchie",
    "onChannels": "WA · Teams",
    "openSource": "Apri sorgente",
    "operatingSystems": "Sistemi operativi",
    "or": "Oppure",
    "organization": "Organizzazione",
    "organizations": "Organizzazioni",
    "origin": "Origine",
    "originalMessage": "Risposta originale",
    "origins": "Sorgenti",
    "outOfStock": "Non disponibile",
    "output": "Output",
    "outputSchema": "Schema di Output",
    "pages": "Pagine",
    "passphrase": "Inserisci la parola chiave",
    "password": "Password",
    "paused": "In pausa",
    "peakHours": "Ore di punta",
    "perMillionTokens": "per milione di token",
    "period": "Periodo",
    "phaseBreakdown": "Breakdown fasi",
    "phone": "Telefono",
    "picture": "Immagine",
    "platformAssistant": "Assistente della piattaforma",
    "platformContext": "Contesto piattaforma",
    "postStreaming": "Post-streaming",
    "preStreaming": "Pre-streaming",
    "preferences": "Preferenze",
    "presencePenalty": "Penalità di Presenza",
    "preview": "Anteprima",
    "priceInput": "Prezzo input",
    "priceOutput": "Prezzo output",
    "priority": "Priorità",
    "priority_1": "Molto Bassa",
    "priority_2": "Bassa",
    "priority_3": "Normale",
    "priority_4": "Alta",
    "priority_5": "Critica",
    "privacy": "Privacy",
    "privacyPolicyNotice": "Informativa privacy",
    "processedAt": "Processato il",
    "processing": "Elaborazione in corso...",
    "profile": "Profilo",
    "prompt": "Prompt",
    "properties": "Proprietà",
    "provider": "Provider",
    "providerOrganizationId": "ID Provider",
    "providerTimeoutMs": "Timeout provider (ms)",
    "qdrantSync": "Sync Vettoriale",
    "qrCode": "Codice QR",
    "question": "Domanda",
    "rateLimits": "Limiti di utilizzo",
    "read": "Letto",
    "reasoning": "Reasoning",
    "reasoningAgentTester": "Test Agente di Ragionamento",
    "reasoningDetails": "Dettagli di ragionamento",
    "reasoningEffort": "Intensità ragionamento",
    "reasoningSummary": "Riepilogo ragionamento",
    "recommended": "Consigliato",
    "redundantChunks": "Chunk ridondanti",
    "referrerDomains": "Domini di provenienza",
    "refillAmount": "Importo ricarica",
    "released": "Rilascio",
    "rememberMe": "Ricordami",
    "replyWithoutText": "Risposta senza testo",
    "requestCount": "Richieste",
    "requestedAt": "Richiesta il",
    "requests": "Richieste",
    "requestsPerAgent": "Richieste per agente",
    "requestsUsed": "Richieste utilizzate",
    "required": "Obbligatorio",
    "requiredFields": "Campi obbligatori",
    "retired": "ritirato",
    "revisedMessage": "Risposta corretta",
    "right": "Destra",
    "riskScoreBands": "Fasce di rischio",
    "role": "Ruolo",
    "rootDocuments": "Senza cartella",
    "scheduledAt": "Programmata il",
    "schemaRootArray": "Array",
    "schemaRootObject": "Oggetto",
    "schemas": "Schemi",
    "screenCategories": "Risoluzione schermo",
    "searchAndExecution": "Ricerca ed esecuzione",
    "searchMode": "Modalità di Ricerca",
    "searchRecencyFilter": "Filtro temporale",
    "sectionChannelBreakdown": "Dettaglio per canale",
    "sectionConversationQuality": "Qualità conversazione",
    "sectionCostTrend": "Andamento costi mensili",
    "sectionDeviceContext": "Dispositivi e contesto (web e widget)",
    "sectionTraffic": "Traffico (web e widget)",
    "security": "Sicurezza",
    "selectAgent": "Seleziona agente",
    "selectedHint": "Selezionato",
    "sentiment": "Sentiment",
    "sentimentTrends": "Trend di sentiment",
    "serverInfo": "Info MCP server",
    "sessionExpiresIn": "Durata sessione (secondi)",
    "setPassword": "Imposta password",
    "settings": "Impostazioni",
    "sfApiVersion": "Versione API",
    "sfClientId": "Client ID",
    "sfClientSecret": "Client Secret",
    "sfExternalIdField": "Campo ID esterno",
    "sfInstanceUrl": "Instance URL",
    "shareWith": "Condividi con gli agenti",
    "showExtendedSteps": "Mostra i passaggi",
    "showing": "Mostrati",
    "similarity": "Similarità",
    "sitemapUrl": "URL Sitemap",
    "size": "Dimensione",
    "slowest": "Più lento",
    "slug": "Slug",
    "smartRanking": "Ranking Intelligente",
    "smoothStream": "Smooth streaming",
    "source": "Sorgente",
    "sources": "Fonti",
    "spokenExchange": "Scambiato a voce",
    "startDate": "Data inizio",
    "startUrl": "URL di Partenza",
    "status": "Stato",
    "steps": "step",
    "streaming": "Streaming",
    "style": "Stile",
    "subAgent": "Sotto-agente",
    "subject": "Oggetto",
    "syncStatus": "Stato",
    "targetAll": "Tutti gli utenti",
    "targetOrganization": "Organizzazione",
    "targetType": "Destinatario",
    "targetUser": "Utente specifico",
    "teams": "Microsoft Teams",
    "teamsAccentColor": "Colore del tema",
    "teamsAppId": "App ID (Microsoft)",
    "teamsAppPassword": "App password / client secret",
    "teamsAppTenantId": "Tenant ID",
    "teamsAppType": "Tipo app",
    "teamsAppVersion": "Versione app",
    "teamsDescriptionFull": "Descrizione completa",
    "teamsDescriptionShort": "Descrizione breve",
    "teamsDeveloperName": "Nome sviluppatore",
    "teamsManifestDetails": "Dettagli dell'app (mostrati in Teams)",
    "temperature": "Temperatura",
    "testConnection": "Verifica connessione",
    "testPlayground": "Test Playground",
    "textColor": "Colore del testo",
    "theme": "Tema",
    "thinking": "Pensiero",
    "thinkingBudget": "Budget ragionamento",
    "thinkingDisplay": "Visualizza ragionamento",
    "thinkingEffort": "Intensità ragionamento",
    "thinkingLevel": "Livello ragionamento",
    "thinkingType": "Tipo pensiero",
    "thisMonth": "Questo mese",
    "timelineSteps": "Timeline steps",
    "timeoutMs": "Timeout (ms)",
    "timezoneRegions": "Fuso orario",
    "title": "Titolo",
    "today": "Oggi",
    "tokens": "token",
    "tool": "Tool",
    "toolApprovalBadge": "Conferma utente",
    "toolName": "Nome del tool: {name}",
    "toolRequiresApproval": "Chiedi conferma all'utente",
    "toolWorkingSet": "Selezione dei tool",
    "toolWorkingSetMode": "Modalità",
    "tools": "Tool",
    "topPages": "Pagine principali",
    "topTopics": "Trending topics",
    "total": "Totale",
    "totalConversations": "Chat in totale",
    "totalCost": "Costo totale",
    "totalCostPartlyEstimated": "Costo totale, in parte stimato",
    "totalItemsCount": "Elementi: {total}",
    "totalMessages": "Messaggi in totale",
    "totalPages": "di {total}",
    "trustedOrigins": "Origini attendibili",
    "tuning": "Tuning",
    "type": "Tipo",
    "typeMain": "Main",
    "typeSub": "Sub",
    "uniqueUsers": "Utenti unici",
    "unitChat": "chat",
    "unitChatPerUser": "chat",
    "unitMessages": "messaggi",
    "unitMessagesPerChat": "messaggi",
    "unitUsers": "utenti",
    "unknown": "Sconosciuto",
    "unread": "Non letto",
    "updateProfile": "Aggiorna profilo",
    "updatedAt": "Aggiornato il",
    "upload": "Carica {index}/{total}",
    "url": "URL pagina web",
    "usage": "Utilizzo",
    "useBrowserEngine": "Utilizza il browser",
    "useExtractionStrategy": "Utilizza l'AI",
    "user": "Utente",
    "userInput": "Opzione selezionata",
    "userPrompt": "Richiesta utente",
    "userQuestion": "Domanda",
    "userTones": "Tono utente",
    "users": "Utenti",
    "utilityModel": "Modello per le funzioni interne",
    "value": "Valore",
    "version": "Versione",
    "video": "Video",
    "viewPdfPage": "Visualizza pagina PDF",
    "visibility": "Visibilità",
    "visualEditor": "Visuale",
    "voice": "Voce",
    "voiceCascadeTimeoutSeconds": "Tempo massimo per rispondere (secondi)",
    "voiceEnabled": "Conversazione vocale",
    "voiceFillerAfterSeconds": "Riempitivo dopo (secondi)",
    "voiceFillerMessage": "Frase di attesa",
    "voiceFirstMessage": "Frase di apertura",
    "voiceId": "Voce",
    "voiceIgnoreBackgroundVoices": "Ignora le voci di sottofondo",
    "voiceLanguage": "Lingua parlata",
    "voiceMaxSessionSeconds": "Durata massima sessione (secondi)",
    "voiceTurnEagerness": "Fine del turno",
    "voiceTurnTimeoutSeconds": "Pausa prima di riprendere la parola (secondi)",
    "vote": "Voto",
    "warnings": "Avvisi",
    "webSearch": "Ricerca web",
    "webSearchEnabled": "Abilita ricerca web",
    "webSearchNative": "Nativa",
    "webSearchProvider": "Provider di ricerca",
    "webhookUrl": "URL Webhook",
    "week": "Settimana",
    "welcome": "Benvenuto in {appName}!",
    "whatsapp": "WhatsApp",
    "whatsappAccessToken": "Access token",
    "whatsappAppSecret": "App secret",
    "whatsappPhoneNumberId": "Phone number ID",
    "whatsappVerifyToken": "Verify token",
    "white": "Bianco",
    "widgetUrl": "URL widget",
    "year": "Anno",
    "yes": "Sì",
    "yesterday": "Ieri",
    "zeroDataRetention": "Zero Data Retention (ZDR)",
    "webPagesRefresh": "Ogni quanto rileggere le pagine",
    "webSourceWatch": "Cerca anche le pagine nuove",
    "webSourceInterval": "Ogni quanto cercarle",
    "webSourceRemoveMissing": "Rimuovi le pagine che escono dalla sitemap"
  },
  "language": {
    "de": "Tedesco",
    "en": "Inglese",
    "english": "Inglese",
    "es": "Spagnolo",
    "fr": "Francese",
    "french": "Francese",
    "german": "Tedesco",
    "it": "Italiano",
    "italian": "Italiano",
    "nl": "Olandese",
    "pt": "Portoghese",
    "spanish": "Spagnolo"
  },
  "lead": {
    "contactReason": {
      "appointment": "Appuntamento",
      "callback_request": "Richiesta di richiamata",
      "complaint": "Reclamo",
      "info_request": "Richiesta informazioni",
      "other": "Altro",
      "quote_request": "Richiesta preventivo",
      "support": "Supporto"
    },
    "label": {
      "budget": "Budget",
      "company": "Azienda",
      "contactReason": "Motivo del contatto",
      "conversationSummary": "Riepilogo conversazione",
      "preferredContactMethod": "Metodo di contatto preferito",
      "preferredContactTime": "Orario di contatto preferito",
      "productInterest": "Prodotto di interesse",
      "sentiment": "Sentiment",
      "topics": "Argomenti",
      "urgency": "Urgenza"
    },
    "preferredContactMethod": {
      "any": "Qualsiasi",
      "email": "Email",
      "phone": "Telefono",
      "whatsapp": "WhatsApp"
    },
    "preferredContactTime": {
      "afternoon": "Pomeriggio",
      "any": "Qualsiasi",
      "evening": "Sera",
      "morning": "Mattina"
    },
    "sentiment": {
      "excited": "Entusiasta",
      "frustrated": "Frustrato",
      "negative": "Negativo",
      "neutral": "Neutro",
      "positive": "Positivo"
    },
    "urgency": {
      "high": "Alta",
      "low": "Bassa",
      "medium": "Media"
    }
  },
  "mcpAuthType": {
    "headers": "Intestazioni HTTP (API Key)",
    "oauth": "OAuth 2.0 per utente"
  },
  "mcpServerStatus": {
    "active": "Attivo",
    "error": "Errore",
    "inactive": "Inattivo"
  },
  "member": {
    "agentAccess": {
      "hint": "Lascia vuoto per consentire al membro di usare tutti gli agenti dell'organizzazione. Seleziona degli agenti per limitarlo solo a quelli.",
      "managerHint": "Owner e admin possono usare tutti gli agenti; il loro accesso non può essere limitato."
    }
  },
  "memorySource": {
    "explicit": "Esplicita | Esplicite",
    "extracted": "Estratta | Estratte"
  },
  "message": {
    "accountLinkAlreadyLinked": "Questo account è già collegato a un altro utente. Accedi con quell'utente per scollegarlo prima.",
    "accountLinkCancelled": "Collegamento annullato sulla pagina del provider. Nulla è cambiato.",
    "accountLinkEmailMismatch": "Puoi collegare solo account che usano la stessa email del tuo profilo.",
    "accountLinkErrorWithCode": "Impossibile collegare l'account (codice: {code}). Riprova o segnala questo codice all'assistenza.",
    "accountLinkNotAllowed": "Questo provider non può essere collegato al tuo profilo: l'email dell'account non è verificata o il collegamento è disabilitato.",
    "accountLinkUserInfo": "Il provider non ha restituito un profilo utilizzabile, quindi nessun account è stato collegato. Riprova.",
    "accountUnlinked": "Account disconnesso",
    "agentAccessDenied": "Non hai accesso a questo agente",
    "agentAccessDeniedAction": "Vedi gli agenti disponibili",
    "agentActivated": "Agente attivato con successo",
    "agentDeactivated": "Agente disattivato con successo",
    "agentNotFound": "Agente non trovato",
    "agentsEmpty": "Nessun agente. Crea il primo per iniziare.",
    "analyzeChatError": "L'analisi non si è conclusa. Riprova fra qualche minuto.",
    "analyzeChatInProgress": "Analisi della conversazione in corso: su una lunga può volerci un minuto.",
    "analyzeChatSuccess": "Conversazione analizzata con successo",
    "apiKeyCreatedForUser": "Copiala adesso e consegnala all'utente su un canale sicuro: non verrà più mostrata.",
    "apiKeysEmpty": "Le chiavi che crei per l’accesso programmatico compaiono qui.",
    "apiToolsEmpty": "Nessun API tool. Aggiungi il primo per far chiamare all'agente un servizio esterno.",
    "banSuccess": "Utente bannato con successo",
    "blockChatSuccess": "Conversazione bloccata con successo",
    "bulkUnlinkAllDeleteConfirm": "{count} documenti verranno eliminati definitivamente perché non hanno altri agenti collegati. Vuoi procedere?",
    "bulkUnlinkMixedConfirm": "{unlinkCount} documenti verranno disassociati e {deleteCount} verranno eliminati definitivamente (non hanno altri agenti collegati). Vuoi procedere?",
    "cancelInvitationConfirm": "Sei sicuro di voler annullare l'invito per {email}?",
    "cancelInvitationSuccess": "Invito annullato con successo",
    "chatActionError": "L'azione non si è conclusa. Riprova fra qualche minuto.",
    "chatAnonymized": "Il contenuto di questa conversazione è stato cancellato (GDPR): restano solo le metriche aggregate.",
    "chatErrorBadRequest": "Si è verificato un errore con la richiesta. Inizia una nuova chat per continuare.",
    "chatErrorContextWindow": "La conversazione è diventata troppo lunga. Inizia una nuova chat per continuare.",
    "chatErrorConversationBlocked": "Questa conversazione è stata bloccata per violazione delle policy.",
    "chatErrorCreditExhausted": "Servizio non disponibile. Riprova più tardi.",
    "chatErrorGatewayDisabled": "Il modello di questo agente non è disponibile: l’organizzazione non usa il gateway AI della piattaforma. Un amministratore può spostare l’agente su uno dei modelli dell’organizzazione.",
    "chatErrorGatewayPromptTraining": "Il modello \"{model}\" non supporta l'opzione \"Disabilita addestramento prompt\". Disattiva questa impostazione nella configurazione del gateway dell'agente oppure scegli un modello compatibile.",
    "chatErrorGatewayZdr": "Il modello \"{model}\" non supporta l'opzione \"Zero Data Retention\". Disattiva ZDR nella configurazione del gateway dell'agente oppure scegli un modello compatibile.",
    "chatErrorGeneric": "Errore durante la richiesta. Se il problema persiste inizia una nuova chat. Riprovo tra {seconds}...",
    "chatErrorInternalServer": "Si è verificato un errore del server. Inizia una nuova chat per continuare.",
    "chatErrorModelUnavailable": "Il modello di questo agente ora non è disponibile: l’endpoint su cui gira è spento o non lo serve più. Un amministratore può riaccenderlo o spostare l’agente su un altro modello.",
    "chatErrorNotFound": "La conversazione non è più disponibile. Inizia una nuova chat per continuare.",
    "chatErrorOriginNotAllowed": "L'origine della richiesta non è consentita. Contatta l'amministratore del sistema.",
    "chatErrorRateLimit": "Il limite di richieste è stato superato. Riprovo tra {seconds} secondi...",
    "chatErrorRetrying": "Riprovo tra {seconds} secondi...",
    "checkYourEmail": "Verifica la tua casella email",
    "clearTimingLogsConfirm": "Svuotare tutti i log di timing?",
    "confirm": "Sei sicuro di voler procedere?",
    "confirmRefillCredits": "Sei sicuro di voler ricaricare il credito di {amount}?",
    "contentTruncated": "Contenuto troncato. Totale caratteri: {total}",
    "copied": "Copiato negli appunti",
    "crawlError": "Errore durante il crawling",
    "createFolderSuccess": "Cartella creata con successo",
    "defaultAgentWelcome": "Ciao! Come posso aiutarti oggi?",
    "defaultPrivacyPolicyNotice": "Inviando la richiesta accetti la nostra [Privacy Policy](https://www.iubenda.com/privacy-policy/46350192).",
    "deleteAgentConfirm": "Le sue cartelle vengono eliminate. Un documento che nessun altro agente usa viene eliminato, uno condiviso resta agli altri agenti.",
    "deleteAllMemoriesConfirm": "Spariscono definitivamente, ricerca semantica compresa.",
    "deleteAllNotificationsConfirm": "Eliminare tutte le notifiche?",
    "deleteBulkDocumentConfirm": "Vengono rimossi da tutti gli agenti collegati.",
    "deleteDocumentConfirm": "Viene rimosso da tutti gli agenti collegati.",
    "deleteDocumentConfirmWithAgents": "Sei sicuro di voler eliminare questo documento? Verrà rimosso dai seguenti agenti:{agents}",
    "deleteError": "Eliminazione non riuscita. Riprova.",
    "deleteFolderConfirm": "I documenti al suo interno vengono tolti da questo agente. Un documento che nessun altro agente usa viene eliminato.",
    "deleteFolderSuccess": "Cartella eliminata con successo",
    "deleteMyConversationsConfirm": "Non si può annullare.",
    "deleteNotificationConfirm": "Eliminare questa notifica?",
    "deleteProfileBlockedSoleOwner": "Sei l'unico proprietario di {organizations}. Trasferisci la proprietà o elimina le organizzazioni prima di poter eliminare l'account.",
    "deleteProfileConfirm": "Stai per eliminare definitivamente il tuo account: il profilo verrà anonimizzato e il contenuto delle tue conversazioni cancellato. Questa azione non può essere annullata.",
    "deleteProfileDescription": "Anonimizza il tuo account e cancella il contenuto delle tue conversazioni (diritto all'oblio).",
    "diagramRenderError": "Impossibile renderizzare il diagramma.",
    "documentRefreshPausedReason": "La pagina non risponde più, quindi l'aggiornamento automatico è in pausa. Aggiorna ora per riprovare.",
    "documentRefreshSet": "Aggiornamento automatico impostato su {updated} documenti, {skipped} saltati perché non sono pagine web",
    "documentRefreshStarted": "Aggiornamento avviato su {queued} documenti, {skipped} saltati",
    "documentsEmpty": "Questa cartella è ancora vuota. Aggiungi documenti dal menu Crea, oppure inizia con una cartella.",
    "documentsEmptyManaged": "Nessun file sincronizzato in questa cartella. Il contenuto arriva dalla sorgente collegata: se hai appena collegato la cartella, il primo import può richiedere qualche minuto.",
    "documentSourceLinked": "Cartella collegata. Il primo import parte tra poco.",
    "documentSourceNothingHere": "Non c’è nulla qui dentro.",
    "documentSourceStale": "Lo stato di questa cartella non è aggiornato: l’ultima lettura non è riuscita.",
    "documentSourceUnlinked": "Cartella scollegata. I documenti restano e ora si modificano come gli altri.",
    "embeddingActivated": "Embedding salvato: l’endpoint serve il modello dichiarato",
    "embeddingBackToPlatform": "I vettori si calcolano di nuovo sulla piattaforma",
    "embeddingIndexNotUpdated": "L’avanzamento non si aggiorna più.",
    "embeddingRemoved": "Embedding rimosso dall’endpoint",
    "empty": "Nessun elemento trovato",
    "endpointActivated": "Endpoint attivato con successo",
    "endpointDeactivated": "Endpoint disattivato con successo",
    "endpointsEmpty": "Nessun endpoint. Crea il primo per esporre l'agente via HTTP.",
    "error": "Errore",
    "errorRetry": "Qualcosa è andato storto. Riprova.",
    "exportError": "Errore durante l'esportazione dei dati",
    "exportFailed": "L'esportazione dei dati non è riuscita. Riprova più tardi.",
    "exportMyDataDescription": "Scarica una copia completa dei tuoi dati personali in formato ZIP (Art. 15 e 20 GDPR).",
    "exportRequested": "Stiamo preparando il tuo archivio: riceverai un'email con il link per scaricarlo.",
    "exportSuccess": "CSV esportato con successo",
    "feedbackSubmitError": "Invio fallito. Riprova per favore.",
    "feedbackSubmittedMessage": "Il tuo feedback è stato inviato con successo.",
    "feedbackSubmittedTitle": "Grazie!",
    "feedbacksEmpty": "I feedback che gli utenti lasciano sulle risposte dell'agente compariranno qui.",
    "fileAlreadyImported": "Già importato",
    "fileAlreadyImportedExistingList": "I seguenti file sono già presenti nell'organizzazione:\n{names}",
    "fileAlreadyImportedLink": "Questo file è già stato importato. Vuoi collegarlo all'agente corrente o creare un nuovo documento?",
    "fileAlreadyImportedNewList": "I seguenti file sono nuovi e verranno importati normalmente:\n{names}",
    "fileAlreadyImportedQuestion": "Vuoi collegare i file già presenti all'agente corrente?",
    "fileAlreadyLinkedToAgent": "I seguenti file sono già collegati all'agente corrente:\n{names}",
    "fileLimitPerChat": "Hai raggiunto il limite di {max} file per questa conversazione.",
    "fileLimitPerMessage": "Puoi allegare al massimo {max} file per messaggio.",
    "foldersEmpty": "Nessuna cartella ancora. Crea la prima dalla pagina dei documenti per organizzarli.",
    "formRenderError": "Non è stato possibile mostrare il modulo. Chiedilo di nuovo e l'assistente lo invierà.",
    "gdprRequestsEmpty": "Le richieste di esportazione o cancellazione dei dati di questo utente compaiono qui.",
    "geolocationPermissionDenied": "Accesso alla posizione negato. Consentilo nelle impostazioni del browser.",
    "geolocationUnavailable": "Posizione non disponibile. Riprova o inserisci la posizione manualmente.",
    "getMcpServerInfoError": "Un errore è avvenuto durante il caricamento dei tool.",
    "importError": "Errore durante l'importazione",
    "importSuccess": "{count} documenti importati con successo",
    "importing": "Importazione in corso...",
    "info": "Informazione",
    "insufficientCredit": "Credito insufficiente. Riprova più tardi.",
    "insufficientCreditMessage": "Il tuo credito è insufficiente per completare questa operazione. Contatta l'amministratore del sistema per ulteriori informazioni.",
    "integrationConnected": "Connessione riuscita.",
    "integrationCreated": "Integrazione creata con successo",
    "integrationDisabled": "Integrazione disabilitata",
    "integrationDisconnected": "Connessione rimossa.",
    "integrationDisconnectConfirm": "Le cartelle sincronizzate vengono scollegate.",
    "integrationEnabled": "Integrazione abilitata",
    "integrationOAuthDenied": "La connessione è stata rifiutata, o manca ancora l’approvazione di un amministratore Microsoft 365.",
    "integrationOAuthFailed": "La connessione non è andata a buon fine.",
    "integrationOAuthStartFailed": "Non è stato possibile avviare la connessione.",
    "integrationRemoveConfirm": "La configurazione di questa integrazione viene rimossa.",
    "integrationTestFailed": "Verifica connessione fallita: {error}",
    "integrationTestSuccess": "Connessione verificata con successo",
    "integrationUpdated": "Integrazione aggiornata con successo",
    "invalidJson": "L'input non è un JSON valido",
    "invitationAccepted": "Invito accettato",
    "invitationAlreadyHandled": "Invito già gestito",
    "invitationDeclined": "Invito declinato",
    "invitationToJoinOrganization": "Sei stato invitato a unirti a",
    "invitationsEmpty": "Nessun invito in sospeso. Invita le persone dalla pagina dei membri.",
    "leadSubmitError": "Invio fallito. Riprova per favore.",
    "leadSubmittedMessage": "La richiesta è stata inviata con successo.",
    "leadSubmittedTitle": "Grazie!",
    "leadsEmpty": "I lead raccolti dall'agente durante le conversazioni compariranno qui.",
    "leftOrganization": "Hai lasciato l'organizzazione con successo",
    "loadConversationsError": "Impossibile caricare le conversazioni",
    "loading": "Caricamento...",
    "loadingError": "Errore durante il caricamento",
    "mcpConnectionConnectedAt": "Accesso effettuato il {date}",
    "mcpConnectionDisconnectDescription": "Gli agenti non useranno più il tuo account {name}. La prossima volta che ti servirà, l'assistente ti chiederà di accedere e potrai scegliere un altro account.",
    "mcpConnectionDisconnectQuestion": "Scollegare {name}?",
    "mcpConnectionDisconnected": "Account {name} scollegato",
    "mcpConnectionsDescription": "I servizi a cui hai effettuato l'accesso da una chat. Scollegane uno per impedire agli agenti di usare il tuo account, o per accedere di nuovo con un account diverso.",
    "mcpServerCheckError": "Errore durante la verifica del server MCP: {error}",
    "mcpServerCheckSuccess": "Verifica del server MCP riuscita",
    "mcpServerInvalidEndpoint": "Questo URL non punta a un endpoint MCP: il server ha risposto con una pagina web. Controlla il percorso, di solito i server MCP lo espongono sotto /mcp.",
    "mcpServersEmpty": "Nessun server MCP. Collega il primo per dare nuovi strumenti all'agente.",
    "membersEmpty": "Nessun membro. Invita il primo per iniziare.",
    "memoriesEmpty": "Le memorie che l'agente salva su questo utente durante le conversazioni compariranno qui.",
    "memoryNotSynced": "Memoria non sincronizzata con la ricerca semantica: non viene considerata nelle risposte finché lo sweep di riparazione non la ripristina.",
    "modelDiscoveryUnavailable": "Questo endpoint non fornisce l'elenco dei suoi modelli: inserisci gli id a mano.",
    "modelDiscoveryFailed": "Non siamo riusciti a leggere l'elenco dei modelli dall'endpoint: vedi solo quelli già salvati.",
    "modelPricesUnchanged": "Nessun prezzo è cambiato.",
    "modelPricesUpdated": "Aggiornato il prezzo di un modello: {models}. | Aggiornati i prezzi di {count} modelli: {models}.",
    "modelProviderDeleted": "Endpoint eliminato.",
    "moveDocumentSuccess": "Documento spostato con successo",
    "noActiveSessions": "Nessuna altra sessione attiva",
    "noApiKeys": "Nessuna chiave API",
    "noChats": "Nessuna chat disponibile",
    "noConnectedAccounts": "Nessun account collegato",
    "noConversations": "Nessuna conversazione trovata",
    "noConversationsHint": "Inizia una nuova chat per vederla comparire qui.",
    "noCreditsData": "Nessun dato crediti disponibile",
    "noEndpointLogs": "Nessun log endpoint disponibile",
    "noEndpointModels": "Nessun modello disponibile: l'endpoint non ne elenca nessuno.",
    "modelRemoved": "Modello rimosso.",
    "noGdprRequests": "Nessuna richiesta GDPR",
    "noLinkedAgents": "Nessun agente collegato",
    "noNotifications": "Nessuna notifica",
    "noOptions": "Nessun elemento",
    "noOrganizations": "Nessuna organizzazione",
    "noResults": "Nessun risultato trovato",
    "noSearchResults": "Nessun elemento corrisponde alla ricerca. Cancellala per vedere tutto.",
    "notificationsEmpty": "Nessuna notifica inviata. Crea la prima per raggiungere i tuoi utenti.",
    "oauthConfigIncomplete": "Configurazione OAuth incompleta. Imposta il Client ID nelle impostazioni del server MCP.",
    "oauthConnected": "Autorizzazione OAuth completata con successo",
    "oauthError": "Errore durante l'autorizzazione OAuth",
    "organizationDisconnected": "Né il gateway della piattaforma né un endpoint proprio servono questa organizzazione, quindi i suoi agenti non rispondono.",
    "organizationMembersEmpty": "Nessun membro. Aggiungi il primo per iniziare.",
    "organizationNotSelected": "Nessuna organizzazione selezionata",
    "organizationsEmpty": "Nessuna organizzazione. Crea la prima per iniziare.",
    "pageNotFound": "Pagina non trovata",
    "passwordChangeSuccess": "Password cambiata con successo",
    "passwordResetSuccess": "Password reimpostata con successo",
    "profileOrganizationsEmpty": "Le organizzazioni di cui fai parte compaiono qui.",
    "readError": "Errore durante la lettura",
    "reasoningAgent": "Questo è un agente di ragionamento. Non è progettato per mantenere la storia della conversazione, ogni messaggio è processato indipendentemente.",
    "recoverPasswordSuccess": "Email di recupero inviata con successo",
    "refillFailed": "Ricarica fallita. Riprova più tardi.",
    "refillSuccess": "Ricarica completata con successo",
    "refreshSuccess": "Aggiornamento completato con successo",
    "releaseNotesEmpty": "Nessuna nota di rilascio pubblicata. Gli aggiornamenti compariranno qui man mano che escono.",
    "removeSuccess": "Eliminazione completata con successo",
    "renameFolderSuccess": "Cartella rinominata con successo",
    "revisedAnswersEmpty": "Nessuna risposta revisionata. Crea la prima per insegnare all'agente una risposta migliore.",
    "selectedCount": "{count} di {total} selezionati",
    "sendInvitationConfirm": "Sei sicuro di voler inviare nuovamente l'invito a {email}?",
    "sessionRevoked": "Sessione disconnessa",
    "sessionsEmpty": "Un accesso da un altro dispositivo o browser apre una nuova sessione, elencata qui.",
    "setPasswordDescription": "Per ora accedi solo tramite un account collegato. Imposta una password per entrare anche con email e password: ti inviamo un link per crearla.",
    "setPasswordLinkSent": "Ti abbiamo mandato il link a {email}.",
    "sharedSuccess": "Documento condiviso con successo",
    "sitemapUrlRequired": "L'URL della sitemap è richiesto",
    "startUrlRequired": "L'URL di partenza è richiesto",
    "subAgentsEmpty": "Collega un agente per delegargli una parte della conversazione.",
    "submitError": "Errore durante il salvataggio",
    "submitSuccess": "Salvataggio completato con successo",
    "success": "Successo",
    "testExecutionError": "Errore nell'esecuzione del test",
    "toolNameAutoGenerated": "Il nome del tool verrà generato in automatico",
    "typeToSearch": "Inizia a digitare per cercare...",
    "unauthorized": "Non hai i permessi per gestire i canali.",
    "unbanSuccess": "Utente sbannato con successo",
    "unblockChatSuccess": "Conversazione sbloccata con successo",
    "unlinkAgentConfirm": "Il documento resta disponibile per gli altri agenti collegati.",
    "unlinkDocumentConfirm": "Resta disponibile per gli altri agenti collegati.",
    "unlinkLastAgentDeleteConfirm": "Il documento viene eliminato definitivamente, perché nessun altro agente è collegato.",
    "unlinkSuccess": "Documento disassociato con successo",
    "unlinkSyncedFolderConfirm": "La sincronizzazione si ferma. La cartella e i suoi documenti restano all'agente e da ora si modificano come gli altri: per toglierli, elimina la cartella.",
    "unsavedChanges": "Salva o annulla le modifiche prima",
    "urlAlreadyImported": "Già importato",
    "urlAlreadyImportedLink": "Questo URL è già stato importato. Vuoi collegarlo all'agente corrente?",
    "userApiKeysEmpty": "Le chiavi che questo utente crea dal proprio profilo per l'accesso programmatico compariranno qui.",
    "userChatsEmpty": "Le conversazioni di questo utente con qualsiasi agente compariranno qui.",
    "userOrganizationsEmpty": "L'utente non appartiene ancora a nessuna organizzazione. Aggiungi la prima.",
    "userUpdateSuccess": "Profilo utente aggiornato con successo",
    "usersEmpty": "Nessun utente. Crea il primo per iniziare.",
    "voiceCancelled": "Ho annullato.",
    "voiceConfirmed": "Confermo.",
    "voiceConnecting": "Connessione…",
    "voiceConnectionDone": "Ho completato il collegamento.",
    "voiceFailed": "La sessione vocale si è interrotta",
    "voiceInterrupted": "Riprova, oppure continua per iscritto.",
    "voiceListening": "In ascolto",
    "voiceLocationRefused": "Preferisco non condividere la mia posizione.",
    "voiceLocationShared": "La mia posizione è {place}.",
    "voiceMuted": "Microfono disattivato",
    "voiceNoAnswer": "L'agente non è riuscito a produrre una risposta per questa chiamata. Riprova, oppure continua per iscritto.",
    "voiceSpeaking": "L'agente sta parlando",
    "voiceTookTooLong": "La risposta ha impiegato troppo tempo per la chiamata. Riprova, oppure continua per iscritto: la risposta comparirà qui appena pronta.",
    "warning": "Attenzione",
    "webSourceCreated": "Sorgente creata: la cartella «{name}» riceverà le pagine nuove.",
    "webSourceCreateError": "Non è stato possibile creare la sorgente, e nessuna pagina è stata importata.",
    "webSourceEditable": "Le pagine scoperte restano modificabili. Scollegare la sorgente le lascia dove sono, con il loro aggiornamento automatico.",
    "webSourceRemovalHeld": "La sitemap non elenca più {count} pagine: sono troppe in una volta per rimuoverle senza un controllo, e non è stato rimosso niente.",
    "webSourceConfirmRemovalQuestion": "Il prossimo controllo toglie dalla knowledge base le pagine che la sitemap non elenca più, fino a {count}. Il loro contenuto resta nel database.",
    "unlinkWebSourceConfirm": "La sorgente smette di cercare pagine nuove. La cartella e le sue pagine restano, con il loro aggiornamento automatico."
  },
  "messagePart": {
    "disconnectOAuthConnection": "Disconnessione in corso...",
    "enableTools": "Attivazione dei tool...",
    "expandChunkContext": "Lettura di altro contesto...",
    "fetchTeamsChannelHistory": "Lettura cronologia canale...",
    "geocode": "Ricerca della posizione...",
    "getWeather": "Recupero dati meteo...",
    "readDocumentFile": "Lettura del documento originale...",
    "reasoning": "Ragionamento...",
    "recallUserMemory": "Richiamo dei ricordi utente...",
    "requestGeolocation": "Richiesta posizione...",
    "requestOAuthConnection": "Connessione in corso...",
    "requestOAuthConnectionButton": "Connetti {name}",
    "requestOAuthConnectionInfo": "Richiesta autorizzazione per accedere i dati di {name}.",
    "requestOAuthConnectionPrompt": "Per accedere ai dati di {name} è necessario autorizzare la connessione.",
    "requestOAuthConnectionSuccess": "Connessione a {name} riuscita.",
    "revisedAnswers": "Ricerca nelle domande ricorrenti...",
    "runSubagent": "Delega a un sotto-agente...",
    "runWorker": "Delega a un worker...",
    "saveUserMemory": "Aggiornamento memoria utente...",
    "searchingDocuments": "Ricerca nella memoria...",
    "showArtifact": "Preparazione contenuto...",
    "showCalendarEvent": "Creazione evento calendario...",
    "showComparison": "Costruzione confronto...",
    "showContactForm": "Creazione modulo contatto...",
    "showDiagram": "Generazione diagramma...",
    "showEmail": "Composizione email...",
    "showForm": "Creazione form...",
    "showImageGallery": "Caricamento galleria...",
    "showLocation": "Caricamento posizione...",
    "showMessage": "Composizione messaggio...",
    "showMultipleChoice": "Mostro le opzioni...",
    "showProducts": "Caricamento prodotti...",
    "showQrCode": "Generazione codice QR...",
    "showSources": "Caricamento fonti...",
    "showSuggestedReply": "Suggerisco una risposta...",
    "showVideo": "Caricamento video...",
    "showWeather": "Caricamento previsioni...",
    "showWebPages": "Caricamento pagine...",
    "stepCount": "{n} passaggio | {n} passaggi",
    "stepDocument": "Documento",
    "stepDropped": "{n} query esclusa: oltre il limite | {n} query escluse: oltre il limite",
    "stepError": "Errore",
    "stepExcerpts": "{n} estratto | {n} estratti",
    "stepInput": "Input",
    "stepItems": "{n} elemento | {n} elementi",
    "stepNoResults": "Nessun risultato trovato",
    "stepOutput": "Output",
    "stepRepeated": "{n} estratto già trovato prima | {n} estratti già trovati prima",
    "stepTimedOut": "{n} ricerca non ha risposto in tempo: i risultati possono essere incompleti | {n} ricerche non hanno risposto in tempo: i risultati possono essere incompleti",
    "steps": "Elaborazione",
    "streaming": "Caricamento...",
    "tool": "Esecuzione di un tool...",
    "webSearch": "Ricerca sul web..."
  },
  "organizationLimits": {
    "legend": "Limiti",
    "membersHint": "Vuoto: nessun limite. Contano anche gli utenti arrivati dal widget.",
    "membersInvalid": "Inserisci un numero intero da 1 in su, oppure lascia vuoto.",
    "membersLabel": "Membri massimi"
  },
  "placeholder": {
    "allProviders": "Tutti i provider",
    "apiToolName": "es. get-product-availability",
    "apiToolUrl": "https://api.example.com/resource/{param}",
    "askAnything": "Scrivi la tua domanda...",
    "autoDetect": "Rileva automaticamente",
    "autoGenerated": "Generata automaticamente se lasciato vuoto",
    "comment": "Scrivi il tuo commento...",
    "completeName": "Inserisci nome e cognome",
    "constValue": "Valore costante",
    "customAnswer": "Scrivi la tua risposta...",
    "description": "Inserisci la descrizione",
    "documentContent": "Inserisci il contenuto del documento",
    "documentName": "Inserisci il nome del documento",
    "documentOriginAll": "Tutte le origini",
    "documentRefreshAll": "Tutti gli aggiornamenti",
    "documentUrl": "Inserisci l'URL della pagina web da importare",
    "email": "Inserisci l'indirizzo email",
    "endDate": "Seleziona data fine",
    "enterYourQuestion": "Inserisci la tua domanda...",
    "insert": "Inserisci...",
    "insertOrigin": "https://example.com",
    "limit": "Inserisci il limite",
    "loading": "Caricamento...",
    "mcpServerHealthCheckPath": "Inserisci l'endpoint per il controllo dello stato",
    "mcpServerUrl": "Inserisci l'URL del server MCP",
    "model": "Seleziona il modello",
    "modelEndpointBaseUrl": "https://internal-proxy/v1",
    "name": "Inserisci il nome",
    "noTrustedOrigins": "Nessuna origine attendibile configurata",
    "oauthAuthorizationUrl": "es. https://provider.com/oauth/authorize",
    "oauthClientId": "es. my-client-app",
    "oauthClientSecret": "Inserisci il client secret",
    "oauthScopes": "es. read:contacts write:contacts",
    "oauthTokenUrl": "es. https://provider.com/oauth/token",
    "pages": "1, 4, 6, 8-12",
    "pasteJsonSample": "Incolla un esempio JSON per generare lo schema",
    "phone": "Inserisci il numero di telefono",
    "prompt": "Inserisci il prompt",
    "request": "Richiesta...",
    "search": "Cerca...",
    "secretEdit": "Lascia vuoto per mantenere il secret attuale",
    "select": "Seleziona",
    "selectAgent": "Seleziona un agente",
    "selectLanguage": "Seleziona lingua",
    "selectPriority": "Seleziona priorità",
    "similarity": "Inserisci la similarità",
    "sitemapUrl": "https://example.com/sitemap.xml",
    "slug": "Inserisci lo slug",
    "startDate": "Seleziona data inizio",
    "startUrl": "https://example.com",
    "temperature": "Inserisci la temperatura",
    "title": "Inserisci il titolo",
    "uploadFile": "Carica un file"
  },
  "problemReasons": {
    "gateway-disabled": {
      "gateway-disabled": "Questa organizzazione non usa il gateway AI della piattaforma, e questo documento ha bisogno di qualcosa che gira lì: l’embedding, se non è attivo sull’endpoint (Modelli, sezione Embedding), oppure il modello AI del documento, da sostituire con uno dell’endpoint."
    },
    "input-validation": {
      "header-env-placeholder": "Un header richiama una variabile d'ambiente della piattaforma, che gli API tool non risolvono più: il valore dell'header parte così come è scritto, quindi scrivi il valore vero.",
      "secret-body-method": "Una richiesta GET o DELETE non ha body: metti i parametri segreti nella query string, oppure cambia il metodo.",
      "secret-env-placeholder": "Un parametro segreto richiama una variabile d'ambiente della piattaforma, che gli API tool non risolvono: scrivi il valore vero.",
      "secret-origin-changed": "L'URL punta a un altro host: riscrivi i valori dei parametri segreti, quelli salvati restano legati all'host precedente.",
      "secret-path-placeholder": "Un parametro segreto non può riempire un segnaposto del percorso dell'URL: il percorso lo compila il modello, che il segreto non lo vede.",
      "secret-url-host-placeholder": "Un tool con parametri segreti ha bisogno di un host fisso: schema, host e porta del suo URL non possono contenere un segnaposto che compila il modello.",
      "secret-value-missing": "Un parametro segreto non ha valore: scrivilo, oppure togli il parametro."
    },
    "model-unavailable": {
      "embedding-endpoint-off": "L’endpoint che calcola l’embedding di questa organizzazione è spento: riaccendilo nella pagina Modelli.",
      "endpoint-off": "Questo documento ha bisogno dell’endpoint dell’organizzazione, per l’embedding o per il modello AI del documento, e l’endpoint è spento: riaccendilo nella pagina Modelli."
    },
    "provider-request-failed": {
      "timeout": "Il provider esterno non ha risposto in tempo: riprova tra qualche istante."
    }
  },
  "problems": {
    "conflict": "Si è verificato un conflitto. La risorsa potrebbe già esistere.",
    "conversation-blocked": "Questa conversazione è stata bloccata.",
    "credit-exhausted": "Crediti esauriti. Contatta l'amministratore.",
    "embedding-identity-failed": "L’endpoint non serve il modello di embedding dichiarato: i suoi vettori non corrisponderebbero alla base di conoscenza. Controlla l’id del modello.",
    "entity-not-found": "Risorsa non trovata o disabilitata.",
    "feature-disabled": "Funzionalità non attiva per la tua organizzazione.",
    "file-upload-disabled": "Il caricamento file non è abilitato per questo agente.",
    "file-upload-validation": "File non valido: verifica dimensione, tipo o numero di file.",
    "gateway-disabled": "Questa organizzazione non usa il gateway AI della piattaforma, quindi i suoi modelli non sono disponibili. Usa un modello dell’endpoint dell’organizzazione.",
    "hubspot-missing-scopes": "Il token HubSpot non ha i permessi necessari. Aggiungi lo scope \"crm.objects.owners.read\".",
    "input-validation": "Validazione input fallita. Verifica il formato dei dati.",
    "internal-server-error": "Si è verificato un errore imprevisto. Riprova più tardi.",
    "mcp-endpoint-invalid": "Questo URL non punta a un endpoint MCP. Controlla il percorso, di solito i server MCP lo espongono sotto /mcp.",
    "method-not-allowed": "Metodo HTTP non consentito per questo endpoint.",
    "model-default-unavailable": "Un modello predefinito deve essere un modello che l’organizzazione può usare: scegli prima un altro predefinito.",
    "model-not-chat": "Questo è un modello di embedding, non di chat: non può rispondere a un agente.",
    "model-price-missing": "Un modello non si attiva senza un prezzo: scegli un modello a cui equivale, o scrivi il prezzo.",
    "model-unavailable": "Il modello scelto non è disponibile per questa organizzazione: scegline un altro.",
    "not-found": "Pagina non trovata.",
    "oauth-authorization-required": "Autorizzazione OAuth richiesta. Completa il flusso di autorizzazione per questo server MCP.",
    "oauth-config-incomplete": "Configurazione OAuth incompleta. Imposta il Client ID per abilitare OAuth.",
    "origin-not-allowed": "L'origine della richiesta non è consentita.",
    "price-list-unavailable": "Il listino del gateway ora non è raggiungibile: riprova, o scrivi il prezzo a mano.",
    "provider-request-failed": "Il provider esterno ha rifiutato la richiesta.",
    "rate-limit-exceeded": "Troppe richieste. Riprova più tardi.",
    "two-factor-required": "Un'organizzazione di cui fai parte richiede la verifica in due passaggi: configurala per continuare.",
    "unauthorized": "Autenticazione richiesta. Effettua l'accesso.",
    "validation-error": "Errore di validazione. Verifica i dati inviati."
  },
  "refreshInterval": {
    "daily": "Ogni giorno",
    "manual": "Manuale",
    "monthly": "Ogni mese",
    "weekly": "Ogni settimana"
  },
  "releaseNotes": {
    "heading": "Novità",
    "installed": "Stai usando la",
    "lead": "Ultime funzionalità, miglioramenti e correzioni."
  },
  "role": {
    "admin": "Amministratore",
    "member": "Membro",
    "owner": "Proprietario",
    "user": "Utente"
  },
  "route": {
    "agentEndpoints": "API Endpoints",
    "agents": "Agenti",
    "apiTools": "API Tools",
    "backoffice": "Backoffice",
    "catalog": "Catalogo",
    "channels": "Canali",
    "chatLogs": "Chat",
    "copatForYou": "Eight Wave for-U",
    "dashboard": "Dashboard",
    "dataProtection": "Protezione dei dati",
    "documents": "Documenti",
    "endpointLogs": "Log endpoint",
    "feedbacks": "Feedback",
    "folders": "Cartelle",
    "frontoffice": "Frontoffice",
    "home": "Home",
    "integrations": "Integrazioni",
    "invitations": "Inviti",
    "leads": "Contatti",
    "mcpServer": "Server MCP",
    "members": "Membri",
    "models": "Modelli",
    "notFound": "Pagina non trovata",
    "notifications": "Notifiche",
    "organizations": "Organizzazioni",
    "playground": "Playground",
    "profile": "Profilo",
    "reasoningLogs": "Ragionamento",
    "releaseNotes": "Note di rilascio",
    "requestPasswordReset": "Password dimenticata",
    "resetPassword": "Reimposta password",
    "revisedAnswers": "Correzioni",
    "signIn": "Accedi",
    "signUp": "Registrati",
    "subAgents": "Sotto-agenti",
    "system": "Sistema",
    "timingDebug": "Debug Performance",
    "twoFactor": "Verifica in due passaggi",
    "twoFactorSetup": "Configura la verifica in due passaggi",
    "users": "Utenti",
    "video": "Video",
    "virtualAssistant": "Assistente virtuale"
  },
  "showForm": {
    "completed": "Completato",
    "otherPlaceholder": "Altro...",
    "step": "Domanda {current} di {total}"
  },
  "subAgentStatus": {
    "active": "Attivo",
    "inactive": "Inattivo"
  },
  "time": {
    "future": "tra",
    "past": "fa",
    "unit": {
      "day": "giorno | giorni",
      "hour": "ora | ore",
      "minute": "minuto | minuti",
      "second": "secondo | secondi"
    }
  },
  "toolApproval": {
    "approved": "Approvato: l'azione è stata eseguita.",
    "cancelled": "Annullato: l'azione non è stata eseguita.",
    "confirmed": "Confermato: l'agente ha proseguito con l'azione.",
    "denied": "Rifiutato: l'azione non è stata eseguita.",
    "expired": "Questa richiesta non è più confermabile: l'azione non è stata eseguita.",
    "prompt": "Per continuare serve la tua conferma:"
  },
  "toolGroup": {
    "channels": "Canali di messaggistica",
    "communication": "Comunicazione",
    "delegation": "Delega e automazione",
    "knowledgeSearch": "Knowledge base e ricerca",
    "locationWeather": "Localizzazione e meteo",
    "personalization": "Personalizzazione",
    "richContent": "Contenuti interattivi"
  },
  "toolGroupInfo": {
    "channels": "Capacità aggiuntive sulle piattaforme di messaggistica come Microsoft Teams.",
    "communication": "Email, messaggi, moduli di contatto ed eventi calendario.",
    "delegation": "Worker generici che l'agente può eseguire in parallelo per gestire sotto-attività indipendenti.",
    "knowledgeSearch": "Ricerca nella knowledge base, fonti documentali e suggerimenti di pagine web.",
    "locationWeather": "Geolocalizzazione, geocodifica, mappe interattive e previsioni meteo.",
    "personalization": "Memoria per-utente e file caricati dall'utente stesso.",
    "richContent": "Contenuti strutturati: artefatti, confronti, gallerie di immagini, codici QR e risposte guidate."
  },
  "toolSelection": {
    "cost": "Costo addebitato all’organizzazione: {cost}",
    "enabled": "Riattivato",
    "exposed": "Gruppi esposti al modello: probabilità da {threshold} in su, o usati prima",
    "failed": "Non riuscita",
    "inputTokens": "Token in ingresso",
    "kind": {
      "api": "API tool",
      "mcp": "Server MCP",
      "subagent": "Sotto-agente"
    },
    "latency": "Tempo della valutazione, limite {budget} ms",
    "leadFailed": "La valutazione non è riuscita o non ha risposto entro {budget} ms: tutti i gruppi sono rimasti esposti.",
    "missed": "Mancato",
    "missedActive": "{n} gruppo usato era stato escluso, e il modello l'ha dovuto riattivare | {n} gruppi usati erano stati esclusi, e il modello li ha dovuti riattivare",
    "missedShadow": "{n} gruppo usato sarebbe stato escluso | {n} gruppi usati sarebbero stati esclusi",
    "mode": {
      "active": "Attiva",
      "shadow": "Ombra"
    },
    "modeHint": {
      "active": "Applicata prima del primo passo: il modello ha visto solo i gruppi con la spunta, e poteva riattivare gli altri.",
      "shadow": "Registrata in parallelo alla risposta: il modello ha visto tutti i gruppi, e la spunta serve solo al confronto con le chiamate."
    },
    "notCharged": "Non addebitata",
    "probability": "Probabilità che il messaggio abbia bisogno del gruppo; esposto da {threshold}",
    "seeded": "Usato in precedenza",
    "title": "Selezione dei tool",
    "tools": "{n} tool | {n} tool",
    "used": "Usato"
  },
  "tooltip": {
    "agentsUsedInfo": "Numero di agenti utilizzati rispetto al massimo disponibile.",
    "requestsUsedInfo": "Numero di richieste utilizzate rispetto al massimo consentito."
  },
  "turnEvaluation": {
    "cost": "Costo, non addebitato all'organizzazione: {cost}",
    "leadFailed": "La valutazione non è riuscita o non ha risposto entro {budget} ms: non è stato registrato niente.",
    "modeHint": "Registrata dopo la risposta, senza effetti: per ora nessuno legge queste probabilità.",
    "probability": "Probabilità che il modello di valutazione dà alla domanda: da 0,5 in su propende per il sì",
    "question": {
      "abusive": "Messaggio offensivo",
      "asksHuman": "Chiede un operatore",
      "durableFact": "Fatto durevole sull'utente",
      "informationGap": "Manca un'informazione, non una capacità",
      "manipulation": "Prova a manipolare l'assistente",
      "missingInfo": "La risposta dice che l'informazione manca"
    },
    "title": "Valutazione a fine turno",
    "version": "Versione delle domande: {version}"
  },
  "twoFactor": {
    "adminBackupCodes": "Nessun codice di recupero rimasto | Un codice di recupero rimasto | {count} codici di recupero rimasti",
    "adminChanges": "Ultime modifiche",
    "adminChangesEmpty": "Ancora nessuna modifica.",
    "adminChangesHint": "Dagli avvisi inviati all'utente, che può cancellarli.",
    "adminDevicesForgotten": "I dispositivi fidati sono stati dimenticati.",
    "adminFailedAttempts": "Un codice sbagliato di fila | {count} codici sbagliati di fila",
    "adminFilterEmpty": "Nessun utente in questo stato.",
    "adminForgetDevices": "Dimentica i dispositivi fidati",
    "adminForgetDevicesDescription": "Su ognuno il prossimo accesso chiederà di nuovo il codice. Glielo diremo per email.",
    "adminForgetDevicesQuestion": "Dimenticare i dispositivi fidati di {name}?",
    "adminLocked": "In pausa dopo troppi codici sbagliati, fino al {date}.",
    "adminPasskeySynced": "Sincronizzata tra i suoi dispositivi",
    "adminRemovePasskeyDescription": "Non servirà più per entrare. Le sessioni già aperte restano: se il dispositivo è perso, chiudile da Sessioni attive. Glielo diremo per email.",
    "adminRemovePasskeyQuestion": "Rimuovere la passkey {passkey} di {name}?",
    "adminRequiredPending": "Richiesta da {organizations} e non ancora configurata: la prossima pagina si fermerà sulla configurazione.",
    "adminStateNoneHint": "Nessun secondo fattore e nessuna passkey",
    "adminSummaryAll": "Tutti",
    "adminTrustedDevices": "Nessun dispositivo fidato | Un dispositivo fidato, fino al {date} | {count} dispositivi fidati, l'ultimo fino al {date}",
    "adminUnlock": "Sblocca",
    "adminUnlockDescription": "Fallo solo se te l'ha chiesto: la pausa rallenta chi sta provando i suoi codici. Glielo diremo per email.",
    "adminUnlocked": "Sbloccata: può inserire di nuovo il codice.",
    "adminUnlockQuestion": "Sbloccare la verifica in due passaggi di {name}?",
    "adoptionRatio": "{count} su {total}",
    "adoptionState": {
      "totp": "Con l'app",
      "otp": "Con l'email",
      "passkey": "Con una passkey",
      "required": "Da configurare",
      "none": "Senza verifica"
    },
    "adoptionTitle": "Membri protetti",
    "backupCode": "Codice di recupero",
    "backupCodesDescription": "Ogni codice vale una volta sola, al posto di quello dell'app. Conservali in un posto sicuro: senza telefono e senza questi codici, solo un amministratore può ridarti l'accesso.",
    "backupCodesFileHeader": "Codici di recupero di Eight Wave Agent Studio. Ognuno vale una volta sola.",
    "backupCodesReplaced": "Ecco i nuovi codici di recupero: quelli vecchi non valgono più. Salvali adesso, non verranno mostrati di nuovo.",
    "backupCodesSaved": "Ho salvato i codici",
    "badge": "Verifica in due passaggi",
    "challengeApp": "Scrivi il codice a 6 cifre della tua app di autenticazione.",
    "challengeBackup": "Scrivi uno dei codici di recupero che hai salvato.",
    "challengeEmailSending": "Ti stiamo inviando un codice via email.",
    "challengeEmailSent": "Ti abbiamo inviato un codice a 6 cifre via email. Scade fra 5 minuti.",
    "challengeTitle": "Verifica in due passaggi",
    "code": "Codice a 6 cifre",
    "column": "2FA",
    "disabledMessage": "La verifica in due passaggi è disattivata.",
    "enabledMessage": "La verifica in due passaggi è attiva.",
    "manualKey": "Non riesci a inquadrarlo? Inserisci questa chiave nell'app:",
    "memberOff": "Non attiva",
    "memberOn": "Attiva",
    "memberPasskey": "Passkey",
    "memberPasskeyHint": "Accede con una passkey, che rispetta l'obbligo. Con la sola password deve prima configurare la verifica.",
    "memberPending": "Da configurare",
    "memberPendingHint": "Accede con la password e non ha un secondo fattore: dovrà configurarlo prima di proseguire",
    "memberSocialOnly": "Non serve",
    "memberSocialOnlyHint": "Accede solo con Google o Microsoft, quindi vale la sicurezza del provider",
    "methodApp": "App di autenticazione",
    "methodAppSummary": "Un codice che cambia ogni 30 secondi, da Google Authenticator, Microsoft Authenticator, 1Password o simili. Consigliata.",
    "methodEmail": "Codice via email",
    "methodEmailSummary": "Un codice inviato a {email} a ogni accesso con la password.",
    "newBackupCodes": "Nuovi codici di recupero",
    "newBackupCodesDescription": "I codici che hai ora smettono di funzionare e ne ricevi dieci nuovi.",
    "passkeyAdd": "Aggiungi una passkey",
    "passkeyAddDescription": "Conferma la password, poi segui il dispositivo: ti chiederà l'impronta, il volto o il PIN.",
    "passkeyAdded": "La passkey è pronta: usala al prossimo accesso.",
    "passkeyAddNoPasswordDescription": "Segui il dispositivo: ti chiederà l'impronta, il volto o il PIN.",
    "passkeyAlreadyRegistered": "Questo dispositivo ha già una passkey per il tuo account.",
    "passkeyCancelled": "Il dispositivo non ha creato la passkey: riprova quando vuoi.",
    "passkeyCreate": "Crea la passkey",
    "passkeyCreatedAt": "Aggiunta il {date}",
    "passkeyDeviceBound": "Solo su un dispositivo",
    "passkeyDeviceRefused": "Il dispositivo non ha creato la passkey. Controlla che abbia un blocco schermo, un'impronta o un PIN e riprova.",
    "passkeyFallbackName": "Passkey",
    "passkeyName": "Nome",
    "passkeyNameHint": "Per riconoscerla nella lista",
    "passkeyRemove": "Rimuovi",
    "passkeyRemoved": "Passkey rimossa.",
    "passkeyRemoveDescription": "Non servirà più per accedere. Puoi aggiungerne una nuova quando vuoi.",
    "passkeyRemoveQuestion": "Rimuovere la passkey {name}?",
    "passkeys": "Passkey",
    "passkeysDescription": "Accedi con l'impronta, il volto o il PIN del dispositivo: niente password e niente codice. Una passkey vale anche per le organizzazioni che richiedono la verifica in due passaggi.",
    "passkeysEmpty": "Nessuna passkey.",
    "passkeySynced": "Sincronizzata tra i tuoi dispositivi",
    "qrLabel": "QR code per l'app di autenticazione",
    "requireConsequence": "I membri che accedono con la password e non l'hanno ancora attiva verranno fermati alla prossima pagina finché non la configurano.",
    "requiredBy": "Richiesta da {organizations}.",
    "requiredByPasskeyEnough": "Richiesta da {organizations}: la tua passkey basta, con la sola password ti verrà chiesto di configurarla.",
    "requireHint": "Chi accede con la password deve configurarla prima di usare la piattaforma. Chi accede con Google o Microsoft non è toccato.",
    "requireLabel": "Richiedi la verifica in due passaggi",
    "requireOff": "La verifica in due passaggi non è più obbligatoria.",
    "requireOn": "Ora la verifica in due passaggi è obbligatoria.",
    "requireQuestion": "Richiedere la verifica in due passaggi ai membri?",
    "requireTitle": "Richiedi la verifica in due passaggi",
    "reset": "Reimposta la verifica in due passaggi",
    "resetConfirm": "Reimposta",
    "resetDescription": "L'app di autenticazione e i codici di recupero smettono di funzionare e l'utente viene disconnesso ovunque. Potrà entrare con la sola password e configurarla di nuovo: lo avvisiamo via email.",
    "resetQuestion": "Reimpostare la verifica in due passaggi di {name}?",
    "scanDescription": "Apri l'app di autenticazione, aggiungi un account e inquadra il QR code. Poi scrivi il codice a 6 cifre che mostra.",
    "sendAgain": "Invia un nuovo codice",
    "setupAddAnotherPasskey": "Aggiungi una nuova passkey",
    "setupAddPasskey": "Usa una passkey",
    "setupDescription": "{organizations} la richiede a chi accede con la password.",
    "setupSignInWithPasskey": "Accedi con la tua passkey",
    "setupTitle": "Configura la verifica in due passaggi",
    "signInState": {
      "totp": "App",
      "otp": "Email",
      "passkey": "Passkey",
      "required": "Da configurare",
      "none": "Non attiva"
    },
    "signInWithPasskey": "Accedi con una passkey",
    "stateNoPassword": "Non disponibile per questo account",
    "stateOff": "Non attiva",
    "stateOnApp": "Attiva, con un'app di autenticazione",
    "stateOnEmail": "Attiva, con un codice via email",
    "summaryNoPassword": "Accedi con Google o Microsoft, quindi vale la sicurezza del provider. Se aggiungi una password, potrai proteggerla anche qui.",
    "summaryOff": "Chiede un codice, oltre alla password, a ogni accesso con email e password.",
    "summaryOnApp": "Nessun codice di recupero rimasto: generane di nuovi. | Un codice di recupero rimasto. | {count} codici di recupero rimasti.",
    "summaryOnEmail": "Il codice arriva a {email}.",
    "switchToApp": "Usa un'app di autenticazione",
    "title": "Verifica in due passaggi",
    "trustDevice": "Ricorda questo dispositivo per 30 giorni",
    "turnOff": "Disattiva",
    "turnOffDescription": "Da adesso per entrare basterà la password. Ti mandiamo un'email di conferma.",
    "turnOffRequired": "Un'organizzazione di cui fai parte la richiede",
    "turnOffTitle": "Disattiva la verifica in due passaggi",
    "turnOn": "Attiva",
    "turnOnTitle": "Attiva la verifica in due passaggi",
    "useApp": "Usa l'app di autenticazione",
    "useBackupCode": "Usa un codice di recupero",
    "verify": "Verifica"
  },
  "userFiles": {
    "allAgents": "Tutti gli agenti",
    "chatFilesEmpty": "Nessun file caricato in questa chat.",
    "chatFilesTitle": "File in questa chat",
    "emptyHint": "I file che carichi in chat vengono aggiunti qui automaticamente e diventano ricercabili dall'assistente.",
    "emptyTitle": "Nessun file",
    "exclude": "Rimuovi file",
    "excludeConfirm": "L'assistente non potrà più cercarlo. Resta nella chat in cui lo avete caricato.",
    "loading": "Caricamento…",
    "open": "Apri file",
    "openInChat": "Apri nella chat",
    "subtitle": "I file che hai caricato in chat, disponibili all'assistente.",
    "title": "I miei file",
    "untitled": "File senza nome",
    "uploadedAt": "Caricato"
  },
  "validation": {
    "duplicateSecretParameter": "Due parametri segreti hanno lo stesso nome",
    "invalidPhoneNumber": "Il numero inserito non è corretto",
    "invalidToolName": "Il nome deve essere in snake_case o kebab-case (lettere minuscole, numeri, underscore e trattini)",
    "passwordMismatch": "Le password non coincidono"
  },
  "voiceEagerness": {
    "eager": "Pronto",
    "normal": "Normale",
    "patient": "Paziente"
  },
  "weather": {
    "airQuality": "Qualità dell'aria",
    "aqiFair": "Discreta",
    "aqiGood": "Buona",
    "aqiHazardous": "Pessima",
    "aqiModerate": "Moderata",
    "aqiPoor": "Scarsa",
    "aqiVeryPoor": "Molto scarsa",
    "dailyForecast": "Previsioni giornaliere",
    "feelsLike": "Percepita",
    "today": "Oggi"
  }
}
